var City = {
  "province": ["北京", "上海", "天津", "重庆", "河北省", "山西省", "河南省", "辽宁省",
    "吉林省", "黑龙江省", "内蒙古省", "江苏省", "山东省", "安徽省", "浙江省", "福建省", "湖北省",
    "湖南省", "广东省", "广西壮族自治区", "江西省", "四川省", "海南省", "贵州省", "云南省", "西藏", "陕西省",
    "甘肃省", "青海省", "宁夏", "新疆", "台湾省", "钓鱼岛", "港澳", "保税区", "亚洲", "欧洲",
    "非洲", "北美洲", "南美洲", "大洋洲", "南极洲"],
  "provinceID": {
    "北京": 1,
    "上海": 2,
    "天津": 3,
    "重庆": 4,
    "河北省": 5,
    "山西省": 6,
    "河南省": 7,
    "辽宁省": 8,
    "吉林省": 9,
    "黑龙江省": 10,
    "内蒙古": 11,
    "江苏省": 12,
    "山东省": 13,
    "安徽省": 14,
    "浙江省": 15,
    "福建省": 16,
    "湖北省": 17,
    "湖南省": 18,
    "广东省": 19,
    "广西壮族自治区": 20,
    "江西省": 21,
    "四川省": 22,
    "海南省": 23,
    "贵州省": 24,
    "云南省": 25,
    "西藏": 26,
    "陕西省": 27,
    "甘肃省": 28,
    "青海省": 29,
    "宁夏": 30,
    "新疆": 31,
    "台湾省": 32,
    "钓鱼岛": 84,
    "港澳": 52993,
    "保税区": 10000004,
    "亚洲": 10000006,
    "欧洲": 10000007,
    "非洲": 10000008,
    "北美洲": 10000009,
    "南美洲": 10000010,
    "大洋洲": 10000011,
    "南极洲": 10000012,
  },
  "city": {
    "北京": ["北京"],
    "上海": ["上海"],
    "天津": ["天津"],
    "重庆": ["重庆"],
    "河北省": ["石家庄市", "邯郸市", "邢台市", "保定市", "张家口市", "承德市", "秦皇岛市", "唐山市", "沧州市", "廊坊市", "衡水市"],
    "山西省": ["太原市", "大同市", "阳泉市", "晋城市", "朔州市", "晋中市", "忻州市", "吕梁市", "临汾市", "运城市", "长治市"],
    "河南省": ["郑州市", "开封市", "洛阳市", "平顶山市", "焦作市", "鹤壁市", "新乡市", "安阳市", "濮阳市", "许昌市", "漯河市", "三门峡市", "南阳市", "商丘市", "周口市", "驻马店市", "信阳市", "济源市"],
    "辽宁省": ["沈阳市", "大连市", "鞍山市", "抚顺市", "本溪市", "丹东市", "锦州市", "葫芦岛市", "营口市", "盘锦市", "阜新市", "辽阳市", "朝阳市", "铁岭市"],
    "吉林省": ["长春市", "吉林市", "四平市", "通化市", "白山市", "松原市", "白城市", "延边州", "辽源市"],
    "黑龙江省": ["哈尔滨市", "齐齐哈尔市", "鹤岗市", "双鸭山市", "鸡西市", "大庆市", "伊春市", "牡丹江市", "佳木斯市", "七台河市", "黑河市", "绥化市", "大兴安岭地区"],
    "内蒙古": ["呼和浩特市", "包头市", "乌海市", "赤峰市", "乌兰察布市", "锡林郭勒盟", "呼伦贝尔市", "鄂尔多斯市", "巴彦淖尔市", "阿拉善盟", "兴安盟", "通辽市"],
    "江苏省": ["南京市", "徐州市", "连云港市", "淮安市", "宿迁市", "盐城市", "扬州市", "泰州市", "南通市", "镇江市", "常州市", "无锡市", "苏州市"],
    "山东省": ["济南市", "青岛市", "淄博市", "枣庄市", "东营市", "潍坊市", "烟台市", "威海市", "莱芜市", "德州市", "临沂市", "聊城市", "滨州市", "菏泽市", "日照市", "泰安市", "济宁市"],
    "安徽省": ["铜陵市", "合肥市", "淮南市", "淮北市", "芜湖市", "蚌埠市", "马鞍山市", "安庆市", "黄山市", "滁州市", "阜阳市", "亳州市", "宿州市", "池州市", "六安市", "宣城市"],
    "浙江省": ["宁波市", "杭州市", "温州市", "嘉兴市", "湖州市", "绍兴市", "金华市", "衢州市", "丽水市", "台州市", "舟山市"],
    "福建省": ["福州市", "厦门市", "三明市", "莆田市", "泉州市", "漳州市", "南平市", "龙岩市", "宁德市"],
    "湖北省": ["武汉市", "黄石市", "襄阳市", "十堰市", "荆州市", "宜昌市", "孝感市", "黄冈市", "咸宁市", "恩施州", "鄂州市", "荆门市", "随州市", "潜江市", "天门市", "仙桃市", "神农架林区"],
    "湖南省": ["长沙市", "株洲市", "湘潭市", "衡阳市", "邵阳市", "岳阳市", "常德市", "张家界市", "郴州市", "益阳市", "永州市", "怀化市", "娄底市", "湘西州"],
    "广东省": ["广州市", "深圳市", "珠海市", "汕头市", "韶关市", "河源市", "梅州市", "惠州市", "汕尾市", "东莞市", "中山市", "江门市", "佛山市", "阳江市", "湛江市", "茂名市", "肇庆市", "云浮市", "清远市", "潮州市", "揭阳市"],
    "广西壮族自治区": ["南宁市", "柳州市", "桂林市", "梧州市", "北海市", "防城港市", "钦州市", "贵港市", "玉林市", "贺州市", "百色市", "河池市", "来宾市", "崇左市"],
    "江西省": ["南昌市", "景德镇市", "萍乡市", "新余市", "九江市", "鹰潭市", "上饶市", "宜春市", "抚州市", "吉安市", "赣州市"],
    "四川省": ["成都市", "自贡市", "攀枝花市", "泸州市", "绵阳市", "德阳市", "广元市", "遂宁市", "内江市", "乐山市", "宜宾市", "广安市", "南充市", "达州市", "巴中市", "雅安市", "眉山市", "资阳市", "阿坝州", "甘孜州", "凉山州"],
    "海南省": ["海口市", "儋州市", "琼海市", "万宁市", "东方市", "三亚市", "文昌市", "五指山市", "临高县", "澄迈县", "定安县", "屯昌县", "昌江县", "白沙县", "琼中县", "陵水县", "保亭县", "乐东县", "三沙市"],
    "贵州省": ["贵阳市", "六盘水市", "遵义市", "铜仁市", "毕节市", "安顺市", "黔西南州", "黔东南州", "黔南州"],
    "云南省": ["昆明市", "曲靖市", "玉溪市", "昭通市", "普洱市", "临沧市", "保山市", "丽江市", "文山州", "红河州", "西双版纳州", "楚雄州", "大理州", "德宏州", "怒江州", "迪庆州"],
    "西藏": ["拉萨市", "那曲地区", "山南地区", "昌都地区", "日喀则地区", "阿里地区", "林芝市"],
    "陕西省": ["西安市", "铜川市", "宝鸡市", "咸阳市", "渭南市", "延安市", "汉中市", "榆林市", "商洛市", "安康市"],
    "甘肃省": ["兰州市", "金昌市", "白银市", "天水市", "嘉峪关市", "平凉市", "庆阳市", "陇南市", "武威市", "张掖市", "酒泉市", "甘南州", "临夏州", "定西市"],
    "青海省": ["西宁市", "海东地区", "海北州", "黄南州", "海南州", "果洛州", "玉树州", "海西州"],
    "宁夏": ["银川市", "石嘴山市", "吴忠市", "固原市", "中卫市"],
    "新疆": ["乌鲁木齐市", "克拉玛依市", "石河子市", "吐鲁番地区", "哈密地区", "和田地区", "阿克苏地区", "喀什地区", "克孜勒苏柯尔克孜自治州", "巴音郭楞州", "昌吉州", "博尔塔拉州", "伊犁州", "塔城地区", "阿勒泰地区", "五家渠市", "阿拉尔市", "图木舒克市", "铁门关市", "昆玉市"],
    "台湾省": ["台湾"],
    "钓鱼岛": ["钓鱼岛"],
    "港澳": ["香港特别行政区", "澳门特别行政区"],
    "保税区": ["广州南沙保税区", "宁波北仑保税区", "杭州萧山保税区", "上海保税区", "郑州保税区", "重庆巴南保税区", "宁波保税区", "深圳保税区", "天津保税区", "广州机场保税区", "重庆保税区", "福州马尾保税区", "杭州下沙保税区", "深圳前海保税区", "福建平潭保税区", "重庆西永保税区"],
    "亚洲": ["中国", "蒙古", "朝鲜", "韩国", "日本", "老挝", "越南", "柬埔寨", "缅甸", "泰国", "马来西亚", "新加坡", "菲律宾", "印度尼西亚", "不丹", "印度", "伊朗", "沙特阿拉伯", "阿拉伯联合酋长国", "中国香港", "中国澳门", "中国台湾"],
    "欧洲": ["比利时", "法国", "爱尔兰", "荷兰", "英国", "丹麦", "芬兰", "挪威", "瑞典", "白俄罗斯", "俄罗斯", "乌克兰", "保加利亚", "克罗地亚", "希腊", "意大利", "葡萄牙", "西班牙", "德国", "波兰", "捷克", "奥地利", "瑞士", "土耳其", "匈牙利"],
    "非洲": ["埃及", "苏丹", "利比亚", "加纳", "尼日利亚"],
    "北美洲": ["美国", "加拿大", "哥斯达黎加", "古巴", "牙买加", "墨西哥", "巴拿马"],
    "南美洲": ["哥伦比亚", "巴西", "智利", "阿根廷"],
    "大洋洲": ["澳大利亚", "新西兰"],
    "南极洲": ["南极洲"]
  },
  "cityID": {
    "石家庄市": 142,
    "邯郸市": 148,
    "邢台市": 164,
    "保定市": 199,
    "张家口市": 224,
    "承德市": 239,
    "秦皇岛市": 248,
    "唐山市": 258,
    "沧州市": 264,
    "廊坊市": 274,
    "衡水市": 275,
    "太原市": 303,
    "大同市": 309,
    "阳泉市": 318,
    "晋城市": 325,
    "朔州市": 330,
    "晋中市": 336,
    "忻州市": 350,
    "吕梁市": 368,
    "临汾市": 379,
    "运城市": 398,
    "长治市": 3074,
    "郑州市": 412,
    "开封市": 420,
    "洛阳市": 427,
    "平顶山市": 438,
    "焦作市": 446,
    "鹤壁市": 454,
    "新乡市": 458,
    "安阳市": 468,
    "濮阳市": 475,
    "许昌市": 482,
    "漯河市": 489,
    "三门峡市": 495,
    "南阳市": 502,
    "商丘市": 517,
    "周口市": 527,
    "驻马店市": 538,
    "信阳市": 549,
    "济源市": 2780,
    "沈阳市": 560,
    "大连市": 573,
    "鞍山市": 579,
    "抚顺市": 584,
    "本溪市": 589,
    "丹东市": 593,
    "锦州市": 598,
    "葫芦岛市": 604,
    "营口市": 609,
    "盘锦市": 613,
    "阜新市": 617,
    "辽阳市": 621,
    "朝阳市": 632,
    "铁岭市": 6858,
    "长春市": 639,
    "吉林市": 644,
    "四平市": 651,
    "通化市": 657,
    "白山市": 664,
    "松原市": 674,
    "白城市": 681,
    "延边州": 687,
    "辽源市": 2992,
    "哈尔滨市": 698,
    "齐齐哈尔市": 712,
    "鹤岗市": 727,
    "双鸭山市": 731,
    "鸡西市": 737,
    "大庆市": 742,
    "伊春市": 753,
    "牡丹江市": 757,
    "佳木斯市": 765,
    "七台河市": 773,
    "黑河市": 776,
    "绥化市": 782,
    "大兴安岭地区": 793,
    "呼和浩特市": 799,
    "包头市": 805,
    "乌海市": 810,
    "赤峰市": 812,
    "乌兰察布市": 823,
    "锡林郭勒盟": 835,
    "呼伦贝尔市": 848,
    "鄂尔多斯市": 870,
    "巴彦淖尔市": 880,
    "阿拉善盟": 891,
    "兴安盟": 895,
    "通辽市": 902,
    "南京市": 904,
    "徐州市": 911,
    "连云港市": 919,
    "淮安市": 925,
    "宿迁市": 933,
    "盐城市": 939,
    "扬州市": 951,
    "泰州市": 959,
    "南通市": 965,
    "镇江市": 972,
    "常州市": 978,
    "无锡市": 984,
    "苏州市": 988,
    "济南市": 1000,
    "青岛市": 1007,
    "淄博市": 1016,
    "枣庄市": 1022,
    "东营市": 1025,
    "潍坊市": 1032,
    "烟台市": 1042,
    "威海市": 1053,
    "莱芜市": 1058,
    "德州市": 1060,
    "临沂市": 1072,
    "聊城市": 1081,
    "滨州市": 1090,
    "菏泽市": 1099,
    "日照市": 1108,
    "泰安市": 1112,
    "济宁市": 2900,
    "铜陵市": 1114,
    "合肥市": 1116,
    "淮南市": 1121,
    "淮北市": 1124,
    "芜湖市": 1127,
    "蚌埠市": 1132,
    "马鞍山市": 1137,
    "安庆市": 1140,
    "黄山市": 1151,
    "滁州市": 1159,
    "阜阳市": 1167,
    "亳州市": 1174,
    "宿州市": 1180,
    "池州市": 1201,
    "六安市": 1206,
    "宣城市": 2971,
    "宁波市": 1158,
    "杭州市": 1213,
    "温州市": 1233,
    "嘉兴市": 1243,
    "湖州市": 1250,
    "绍兴市": 1255,
    "金华市": 1262,
    "衢州市": 1273,
    "丽水市": 1280,
    "台州市": 1290,
    "舟山市": 1298,
    "福州市": 1303,
    "厦门市": 1315,
    "三明市": 1317,
    "莆田市": 1329,
    "泉州市": 1332,
    "漳州市": 1341,
    "南平市": 1352,
    "龙岩市": 1362,
    "宁德市": 1370,
    "武汉市": 1381,
    "黄石市": 1387,
    "襄阳市": 1396,
    "十堰市": 1405,
    "荆州市": 1413,
    "宜昌市": 1421,
    "孝感市": 1432,
    "黄冈市": 1441,
    "咸宁市": 1458,
    "恩施州": 1466,
    "鄂州市": 1475,
    "荆门市": 1477,
    "随州市": 1479,
    "潜江市": 2922,
    "天门市": 2980,
    "仙桃市": 2983,
    "神农架林区": 3154,
    "长沙市": 1482,
    "株洲市": 1488,
    "湘潭市": 1495,
    "衡阳市": 1501,
    "邵阳市": 1511,
    "岳阳市": 1522,
    "常德市": 1530,
    "张家界市": 1540,
    "郴州市": 1544,
    "益阳市": 1555,
    "永州市": 1560,
    "怀化市": 1574,
    "娄底市": 1586,
    "湘西州": 1592,
    "广州市": 1601,
    "深圳市": 1607,
    "珠海市": 1609,
    "汕头市": 1611,
    "韶关市": 1617,
    "河源市": 1627,
    "梅州市": 1634,
    "惠州市": 1643,
    "汕尾市": 1650,
    "东莞市": 1655,
    "中山市": 1657,
    "江门市": 1659,
    "佛山市": 1666,
    "阳江市": 1672,
    "湛江市": 1677,
    "茂名市": 1684,
    "肇庆市": 1690,
    "云浮市": 1698,
    "清远市": 1704,
    "潮州市": 1705,
    "揭阳市": 1709,
    "南宁市": 1715,
    "柳州市": 1720,
    "桂林市": 1726,
    "梧州市": 1740,
    "北海市": 1746,
    "防城港市": 1749,
    "钦州市": 1753,
    "贵港市": 1757,
    "玉林市": 1761,
    "贺州市": 1792,
    "百色市": 1806,
    "河池市": 1818,
    "来宾市": 3044,
    "崇左市": 3168,
    "南昌市": 1827,
    "景德镇市": 1832,
    "萍乡市": 1836,
    "新余市": 1842,
    "九江市": 1845,
    "鹰潭市": 1857,
    "上饶市": 1861,
    "宜春市": 1874,
    "抚州市": 1885,
    "吉安市": 1898,
    "赣州市": 1911,
    "成都市": 1930,
    "自贡市": 1946,
    "攀枝花市": 1950,
    "泸州市": 1954,
    "绵阳市": 1960,
    "德阳市": 1962,
    "广元市": 1977,
    "遂宁市": 1983,
    "内江市": 1988,
    "乐山市": 1993,
    "宜宾市": 2005,
    "广安市": 2016,
    "南充市": 2022,
    "达州市": 2033,
    "巴中市": 2042,
    "雅安市": 2047,
    "眉山市": 2058,
    "资阳市": 2065,
    "阿坝州": 2070,
    "甘孜州": 2084,
    "凉山州": 2103,
    "海口市": 2121,
    "儋州市": 3034,
    "琼海市": 3115,
    "万宁市": 3137,
    "东方市": 3173,
    "三亚市": 3690,
    "文昌市": 3698,
    "五指山市": 3699,
    "临高县": 3701,
    "澄迈县": 3702,
    "定安县": 3703,
    "屯昌县": 3704,
    "昌江县": 3705,
    "白沙县": 3706,
    "琼中县": 3707,
    "陵水县": 3708,
    "保亭县": 3709,
    "乐东县": 3710,
    "三沙市": 3711,
    "贵阳市": 2144,
    "六盘水市": 2150,
    "遵义市": 2155,
    "铜仁市": 2169,
    "毕节市": 2180,
    "安顺市": 2189,
    "黔西南州": 2196,
    "黔东南州": 2205,
    "黔南州": 2222,
    "昆明市": 2235,
    "曲靖市": 2247,
    "玉溪市": 2258,
    "昭通市": 2270,
    "普洱市": 2281,
    "临沧市": 2291,
    "保山市": 2298,
    "丽江市": 2304,
    "文山州": 2309,
    "红河州": 2318,
    "西双版纳州": 2332,
    "楚雄州": 2336,
    "大理州": 2347,
    "德宏州": 2360,
    "怒江州": 2366,
    "迪庆州": 4108,
    "拉萨市": 2951,
    "那曲地区": 3107,
    "山南地区": 3129,
    "昌都地区": 3138,
    "日喀则地区": 3144,
    "阿里地区": 3970,
    "林芝市": 3971,
    "西安市": 2376,
    "铜川市": 2386,
    "宝鸡市": 2390,
    "咸阳市": 2402,
    "渭南市": 2416,
    "延安市": 2428,
    "汉中市": 2442,
    "榆林市": 2454,
    "商洛市": 2468,
    "安康市": 2476,
    "兰州市": 2487,
    "金昌市": 2492,
    "白银市": 2495,
    "天水市": 2501,
    "嘉峪关市": 2509,
    "平凉市": 2518,
    "庆阳市": 2525,
    "陇南市": 2534,
    "武威市": 2544,
    "张掖市": 2549,
    "酒泉市": 2556,
    "甘南州": 2564,
    "临夏州": 2573,
    "定西市": 3080,
    "西宁市": 2580,
    "海东地区": 2585,
    "海北州": 2592,
    "黄南州": 2597,
    "海南州": 2603,
    "果洛州": 2605,
    "玉树州": 2612,
    "海西州": 2620,
    "银川市": 2628,
    "石嘴山市": 2632,
    "吴忠市": 2637,
    "固原市": 2644,
    "中卫市": 3071,
    "乌鲁木齐市": 2652,
    "克拉玛依市": 2654,
    "石河子市": 2656,
    "吐鲁番地区": 2658,
    "哈密地区": 2662,
    "和田地区": 2666,
    "阿克苏地区": 2675,
    "喀什地区": 2686,
    "克孜勒苏柯尔克孜自治州": 2699,
    "巴音郭楞州": 2704,
    "昌吉州": 2714,
    "博尔塔拉州": 2723,
    "伊犁州": 2727,
    "塔城地区": 2736,
    "阿勒泰地区": 2744,
    "五家渠市": 4110,
    "阿拉尔市": 15945,
    "图木舒克市": 15946,
    "铁门关市": 53090,
    "昆玉市": 53668,
    "台湾": 2768,
    "钓鱼岛": 1310,
    "香港特别行政区": 52994,
    "澳门特别行政区": 52995,
    "广州南沙保税区": 10000001,
    "宁波北仑保税区": 10000002,
    "杭州萧山保税区": 10000003,
    "上海保税区": 10000078,
    "郑州保税区": 10000079,
    "重庆巴南保税区": 10000080,
    "宁波保税区": 10000081,
    "深圳保税区": 10000082,
    "天津保税区": 10000083,
    "广州机场保税区": 10000084,
    "重庆保税区": 10000085,
    "福州马尾保税区": 10000087,
    "杭州下沙保税区": 10000088,
    "深圳前海保税区": 10000089,
    "福建平潭保税区": 10000090,
    "重庆西永保税区": 10000091,
    "中国": 10000013,
    "蒙古": 10000014,
    "朝鲜": 10000015,
    "韩国": 10000016,
    "日本": 10000017,
    "老挝": 10000018,
    "越南": 10000019,
    "柬埔寨": 10000020,
    "缅甸": 10000021,
    "泰国": 10000022,
    "马来西亚": 10000023,
    "新加坡": 10000024,
    "菲律宾": 10000025,
    "印度尼西亚": 10000026,
    "不丹": 10000027,
    "印度": 10000028,
    "伊朗": 10000029,
    "沙特阿拉伯": 10000030,
    "阿拉伯联合酋长国": 10000031,
    "中国香港": 10000075,
    "中国澳门": 10000076,
    "中国台湾": 10000077,
    "比利时": 10000032,
    "法国": 10000033,
    "爱尔兰": 10000034,
    "荷兰": 10000035,
    "英国": 10000036,
    "丹麦": 10000037,
    "芬兰": 10000038,
    "挪威": 10000039,
    "瑞典": 10000041,
    "白俄罗斯": 10000042,
    "俄罗斯": 10000043,
    "乌克兰": 10000044,
    "保加利亚": 10000045,
    "克罗地亚": 10000046,
    "希腊": 10000047,
    "意大利": 10000048,
    "葡萄牙": 10000049,
    "西班牙": 10000050,
    "德国": 10000051,
    "波兰": 10000052,
    "捷克": 10000053,
    "奥地利": 10000054,
    "瑞士": 10000055,
    "土耳其": 10000056,
    "匈牙利": 10000086,
    "埃及": 10000057,
    "苏丹": 10000058,
    "利比亚": 10000059,
    "加纳": 10000060,
    "尼日利亚": 10000061,
    "美国": 10000062,
    "加拿大": 10000063,
    "哥斯达黎加": 10000064,
    "古巴": 10000065,
    "牙买加": 10000066,
    "墨西哥": 10000067,
    "巴拿马": 10000068,
    "哥伦比亚": 10000069,
    "巴西": 10000070,
    "智利": 10000071,
    "阿根廷": 10000072,
    "澳大利亚": 10000073,
    "新西兰": 10000074,
    "": 0,
  },
  "region": {
    "北京":["朝阳区","海淀区","西城区","东城区","崇文区","宣武区","丰台区","石景山区","门头沟","房山区","通州区","大兴区","顺义区","怀柔区","密云区","昌平区","平谷区","延庆县"],
    "上海":["黄浦区","徐汇区","长宁区","静安区","闸北区","虹口区","杨浦区","宝山区","闵行区","嘉定区","浦东新区","青浦区","松江区","金山区","奉贤区","普陀区","崇明县"],
    "天津":["东丽区","和平区","河北区","河东区","河西区","红桥区","蓟县","静海县","南开区","塘沽区","西青区","武清区","津南区","汉沽区","大港区","北辰区","宝坻区","宁河县"],
    "重庆":["万州区","涪陵区","梁平区","南川区","潼南区","大足区","黔江区","武隆区","丰都县","奉节县","开州区","云阳县","忠县","巫溪县","巫山县","石柱县","彭水县","垫江县","酉阳县","秀山县","城口县","璧山区","荣昌区","铜梁区","合川区","巴南区","北碚区","江津区","渝北区","长寿区","永川区","江北区","南岸区","九龙坡区","沙坪坝区","大渡口区","綦江区","渝中区","高新区","北部新区"],
    "石家庄市": ["辛集市", "晋州市", "新乐市", "井陉县", "栾城县", "行唐县", "灵寿县", "高邑县", "赵县", "赞皇县", "深泽县", "无极县", "元氏县", "井陉矿区", "平山县", "藁城市", "鹿泉市", "正定县", "新华区", "桥西区", "桥东区", "裕华区", "长安区"],
    "邯郸市": ["邯郸县", "峰峰矿区", "曲周县", "馆陶县", "魏县", "成安县", "大名县", "涉县", "鸡泽县", "邱县", "广平县", "肥乡县", "磁县", "临漳县", "永年县", "丛台区", "邯山区", "复兴区", "武安市"],
    "邢台市": ["邢台县", "南宫市", "沙河市", "柏乡县", "任县", "清河县", "隆尧县", "临城县", "广宗县", "临西县", "内丘县", "平乡县", "巨鹿县", "新河县", "南和县", "宁晋县", "威县", "桥西区", "桥东区"],
    "保定市": ["安国市", "满城县", "清苑县", "涞水县", "阜平县", "定兴县", "唐县", "高阳县", "容城县", "涞源县", "望都县", "易县", "曲阳县", "蠡县", "顺平县", "博野县", "雄县", "新市区", "北市区", "南市区", "安新县", "涿州市", "定州市", "徐水县", "高碑店市"],
    "张家口市": ["宣化县", "康保县", "张北县", "阳原县", "赤城县", "怀安县", "怀来县", "崇礼县", "尚义县", "蔚县", "涿鹿县", "万全县", "下花园区", "沽源县", "宣化区", "桥西区", "桥东区"],
    "承德市": ["兴隆县", "平泉市", "滦平县", "丰宁县", "围场县", "宽城县", "隆化县", "承德县", "双滦区", "鹰手营子矿区", "双桥区"],
    "秦皇岛市": ["卢龙县", "青龙县", "昌黎县", "北戴河区", "抚宁县", "海港区", "山海关区"],
    "唐山市": ["遵化市", "丰南区", "迁西县", "滦南县", "玉田县", "曹妃甸区", "乐亭县", "滦县", "古冶区", "开平区", "路北区", "路南区", "迁安市", "丰润区"],
    "沧州市": ["沧县", "泊头市", "河间市", "献县", "肃宁县", "青县", "东光县", "吴桥县", "南皮县", "盐山县", "海兴县", "孟村县", "运河区", "新华区", "任丘市", "黄骅市"],
    "廊坊市": ["固安县", "永清县", "香河县", "大城县", "文安县", "大厂县", "安次区", "广阳区", "开发区", "三河市", "霸州市"],
    "衡水市": ["冀州市", "深州市", "饶阳县", "枣强县", "故城县", "阜城县", "安平县", "武邑县", "景县", "武强县", "桃城区"],
    "太原市": ["阳曲县", "古交市", "娄烦县", "清徐县", "小店区", "迎泽区", "晋源区", "万柏林区", "尖草坪区", "杏花岭区"],
    "大同市": ["大同县", "天镇县", "灵丘县", "阳高县", "左云县", "浑源县", "广灵县", "新荣区", "南郊区", "矿区", "城区"],
    "阳泉市": ["盂县", "平定县", "郊区", "矿区", "城区"],
    "晋城市": ["高平市", "阳城县", "沁水县", "陵川县", "泽州县", "城区"],
    "朔州市": ["山阴县", "右玉县", "应县", "怀仁县", "朔城区", "平鲁区"],
    "晋中市": ["介休市", "昔阳县", "祁县", "左权县", "寿阳县", "太谷县", "和顺县", "灵石县", "平遥县", "榆社县", "榆次区"],
    "忻州市": ["原平市", "代县", "神池县", "五寨县", "五台县", "偏关县", "宁武县", "静乐县", "繁峙县", "河曲县", "保德县", "定襄县", "忻府区", "岢岚县"],
    "吕梁市": ["离石区", "孝义市", "汾阳市", "文水县", "中阳县", "兴县", "临县", "方山县", "柳林县", "岚县", "交口县", "交城县", "石楼县"],
    "临汾市": ["侯马市", "霍州市", "汾西县", "吉县", "安泽县", "浮山县", "大宁县", "古县", "隰县", "襄汾县", "翼城县", "永和县", "乡宁县", "洪洞县", "蒲县", "曲沃县", "尧都区"],
    "运城市": ["河津市", "永济市", "新绛县", "平陆县", "垣曲县", "绛县", "稷山县", "芮城县", "夏县", "临猗县", "万荣县", "闻喜县", "盐湖区"],
    "长治市": ["长治县", "潞城市", "郊区", "襄垣县", "屯留县", "平顺县", "黎城县", "壶关县", "长子县", "武乡县", "沁县", "沁源县", "城区"],
    "郑州市": ["新密市", "登封市", "上街区", "惠济区", "金水区", "管城区", "二七区", "中原区", "郑东新区", "新郑市", "巩义市", "荥阳市", "中牟县", "经济开发区", "高新技术开发区"],
    "开封市": ["开封县", "杞县", "兰考县", "尉氏县", "通许县", "金明区", "龙亭区", "顺河区", "鼓楼区", "禹王台区"],
    "洛阳市": ["偃师市", "孟津县", "汝阳县", "伊川县", "洛宁县", "宜阳县", "栾川县", "新安县", "吉利区", "涧西区", "瀍河区", "老城区", "西工区", "嵩县", "伊滨区", "洛龙区"],
    "平顶山市": ["汝州市", "舞钢市", "郏县", "叶县", "鲁山县", "宝丰县", "石龙区", "湛河区", "卫东区", "新华区"],
    "焦作市": ["沁阳市", "孟州市", "修武县", "温县", "武陟县", "博爱县", "山阳区", "解放区", "马村区", "中站区"],
    "鹤壁市": ["浚县", "淇县", "鹤山区", "山城区", "淇滨区"],
    "新乡市": ["卫辉市", "辉县市", "新乡县", "获嘉县", "原阳县", "长垣县", "延津县", "封丘县", "凤泉区", "牧野区", "红旗区", "卫滨区"],
    "安阳市": ["林州市", "安阳县", "滑县", "汤阴县", "内黄县", "龙安区", "殷都区", "文峰区", "开发区", "北关区"],
    "濮阳市": ["濮阳县", "南乐县", "台前县", "清丰县", "范县", "华龙区"],
    "许昌市": ["禹州市", "长葛市", "建安区", "鄢陵县", "襄城县", "魏都区"],
    "漯河市": ["郾城区", "临颍县", "召陵区", "舞阳县", "源汇区"],
    "三门峡市": ["义马市", "灵宝市", "陕县", "卢氏县", "渑池县", "湖滨区"],
    "南阳市": ["邓州市", "桐柏县", "方城县", "淅川县", "镇平县", "唐河县", "南召县", "内乡县", "新野县", "社旗县", "西峡县", "卧龙区", "宛城区"],
    "商丘市": ["永城市", "宁陵县", "虞城县", "民权县", "夏邑县", "柘城县", "睢县", "睢阳区", "梁园区"],
    "周口市": ["项城市", "商水县", "淮阳县", "太康县", "鹿邑县", "西华县", "扶沟县", "沈丘县", "郸城县", "东新区", "经济开发区", "川汇区"],
    "驻马店市": ["确山县", "新蔡县", "上蔡县", "泌阳县", "西平县", "遂平县", "汝南县", "平舆县", "正阳县", "驿城区"],
    "信阳市": ["潢川县", "淮滨县", "息县", "新县", "固始县", "罗山县", "光山县", "商城县", "平桥区", "浉河区"],
    "济源市": ["五龙口镇", "下冶镇", "轵城镇", "王屋镇", "思礼镇", "邵原镇", "坡头镇", "梨林镇", "克井镇", "大峪镇", "承留镇", "城区"],
    "沈阳市": ["苏家屯区", "新民市", "法库县", "辽中县", "康平县", "皇姑区", "铁西区", "大东区", "沈河区", "东陵区", "于洪区", "和平区", "浑南新区", "沈北新区"],
    "大连市": ["普兰店市", "瓦房店市", "庄河市", "长海县", "沙河口区", "西岗区", "中山区", "甘井子区", "高新园区", "大连开发区", "金州区", "旅顺口区"],
    "鞍山市": ["台安县", "海城市", "岫岩县", "铁东区", "立山区", "铁西区", "千山区"],
    "抚顺市": ["抚顺县", "新宾县", "清原县", "望花区", "东洲区", "新抚区", "顺城区"],
    "本溪市": ["桓仁县", "南芬区", "本溪县", "平山区", "溪湖区", "明山区"],
    "丹东市": ["宽甸县", "元宝区", "振兴区", "振安区", "东港市", "凤城市"],
    "锦州市": ["义县", "凌海市", "北镇市", "黑山县", "古塔区", "凌河区", "太和区", "经济技术开发区"],
    "葫芦岛市": ["绥中县", "建昌县", "南票区", "龙港区", "连山区", "兴城市"],
    "营口市": ["大石桥市", "盖州市", "老边区", "西市区", "站前区", "鲅鱼圈区"],
    "盘锦市": ["盘山县", "大洼县", "兴隆台区", "双台子区"],
    "阜新市": ["阜新县", "彰武县", "清河门区", "新邱区", "海州区", "太平区", "细河区"],
    "辽阳市": ["辽阳县", "太子河区", "弓长岭区", "宏伟区", "白塔区", "文圣区", "灯塔市"],
    "朝阳市": ["凌源市", "北票市", "喀喇沁左翼县", "朝阳县", "建平县", "龙城区", "双塔区"],
    "铁岭市": ["银州区", "清河区", "开原市", "铁岭县", "西丰县", "昌图县", "调兵山市"],
    "长春市": ["榆树市", "九台市", "农安县", "德惠市", "双阳区", "朝阳区", "南关区", "宽城区", "二道区", "绿园区", "净月区", "汽车产业开发区", "高新技术开发区", "经济技术开发区"],
    "吉林市": ["舒兰市", "桦甸市", "蛟河市", "磐石市", "永吉县", "昌邑区", "龙潭区", "船营区", "丰满区"],
    "四平市": ["公主岭市", "双辽市", "梨树县", "伊通县", "铁东区", "铁西区"],
    "通化市": ["梅河口市", "集安市", "通化县", "辉南县", "柳河县", "二道江区", "东昌区"],
    "白山市": ["临江市", "江源区", "靖宇县", "抚松县", "长白县", "浑江区"],
    "松原市": ["乾安县", "长岭县", "扶余县", "宁江区", "前郭县"],
    "白城市": ["大安市", "洮南市", "通榆县", "镇赉县", "洮北区"],
    "延边州": ["图们市", "敦化市", "珲春市", "龙井市", "和龙市", "汪清县", "安图县", "延吉市"],
    "辽源市": ["龙山区", "西安区", "东丰县", "东辽县"],
    "哈尔滨市": ["阿城区", "尚志市", "双城市", "五常市", "方正县", "宾县", "依兰县", "巴彦县", "通河县", "木兰县", "延寿县", "呼兰区", "松北区", "道里区", "南岗区", "道外区", "香坊区", "平房区"],
    "齐齐哈尔市": ["梅里斯区", "昂昂溪区", "富拉尔基区", "碾子山区", "讷河市", "富裕县", "拜泉县", "甘南县", "依安县", "克山县", "龙江县", "克东县", "泰来县", "建华区", "龙沙区", "铁锋区"],
    "鹤岗市": ["萝北县", "绥滨县", "兴山区", "向阳区", "工农区", "南山区", "兴安区", "东山区"],
    "双鸭山市": ["集贤县", "宝清县", "友谊县", "饶河县", "尖山区", "岭东区", "四方台区", "宝山区"],
    "鸡西市": ["密山市", "虎林市", "鸡东县", "恒山区", "滴道区", "梨树区", "城子河区", "麻山区", "鸡冠区"],
    "大庆市": ["萨尔图区", "龙凤区", "让胡路区", "红岗区", "大同区", "林甸县", "肇州县", "肇源县", "杜尔伯特县"],
    "伊春市": ["铁力市", "嘉荫县", "伊春区", "南岔区", "友好区", "西林区", "翠峦区", "新青区", "美溪区", "金山屯区", "五营区", "乌马河区", "汤旺河区", "带岭区", "乌伊岭区", "红星区", "上甘岭区"],
    "牡丹江市": ["海林市", "宁安市", "穆棱市", "林口县", "东宁县", "爱民区", "东安区", "阳明区", "西安区", "绥芬河市"],
    "佳木斯市": ["同江市", "富锦市", "桦川县", "抚远县", "桦南县", "汤原县", "前进区", "向阳区", "东风区", "郊区"],
    "七台河市": ["勃利县", "桃山区", "新兴区", "茄子河区", "金沙新区"],
    "黑河市": ["北安市", "五大连池市", "逊克县", "孙吴县", "嫩江县", "爱辉区"],
    "绥化市": ["安达市", "肇东市", "海伦市", "绥棱县", "兰西县", "明水县", "青冈县", "庆安县", "望奎县", "北林区"],
    "大兴安岭地区": ["呼玛县", "塔河县", "漠河县", "加格达奇区", "松岭区", "呼中区", "新林区"],
    "呼和浩特市": ["土默特左旗", "和林格尔县", "武川县", "托克托县", "清水河县", "玉泉区", "赛罕区", "回民区", "新城区"],
    "包头市": ["固阳县", "土默特右旗", "达茂联合旗", "石拐区", "白云矿区", "东河区", "九原区", "青山区", "昆都仑区"],
    "乌海市": ["海勃湾区", "海南区", "乌达区"],
    "赤峰市": ["宁城县", "敖汉旗", "喀喇沁旗", "翁牛特旗", "巴林右旗", "林西县", "克什克腾旗", "巴林左旗", "阿鲁科尔沁旗", "元宝山区", "松山区", "红山区"],
    "乌兰察布市": ["集宁区", "丰镇市", "兴和县", "卓资县", "商都县", "凉城县", "化德县", "察哈尔右翼前旗", "察哈尔右翼中旗", "察哈尔右翼后旗", "四子王旗"],
    "锡林郭勒盟": ["锡林浩特市", "二连浩特市", "多伦县", "阿巴嘎旗", "西乌珠穆沁旗", "东乌珠穆沁旗", "苏尼特右旗", "苏尼特左旗", "太仆寺旗", "正镶白旗", "正蓝旗", "镶黄旗"],
    "呼伦贝尔市": ["海拉尔区", "满洲里市", "牙克石市", "扎兰屯市", "根河市", "额尔古纳市", "陈巴尔虎旗", "阿荣旗", "新巴尔虎左旗", "新巴尔虎右旗", "鄂伦春旗", "莫力达瓦旗", "鄂温克族旗"],
    "鄂尔多斯市": ["东胜区", "准格尔旗", "伊金霍洛旗", "乌审旗", "杭锦旗", "鄂托克旗", "鄂托克前旗", "达拉特旗", "康巴什新区"],
    "巴彦淖尔市": ["临河区", "五原县", "磴口县", "杭锦后旗", "乌拉特中旗", "乌拉特后旗 ", "乌拉特前旗"],
    "阿拉善盟": ["阿拉善右旗", "阿拉善左旗", "额济纳旗"],
    "兴安盟": ["乌兰浩特市", "阿尔山市", "突泉县", "扎赉特旗", "科尔沁右翼前旗", "科尔沁右翼中旗"],
    "通辽市": ["霍林郭勒市", "开鲁县", "库伦旗", "奈曼旗", "扎鲁特旗", "科尔沁左翼中旗", "科尔沁左翼后旗", "科尔沁区"],
    "南京市": ["江宁区", "高淳区", "六合区", "溧水区", "玄武区", "秦淮区", "建邺区", "鼓楼区", "栖霞区", "雨花台区", "浦口区"],
    "徐州市": ["铜山区", "睢宁县", "沛县", "丰县", "贾汪区", "金山桥开发区", "铜山经济技术开发区", "八段工业园区", "鼓楼区", "邳州市", "泉山区", "新沂市", "云龙区"],
    "连云港市": ["赣榆区", "灌云县", "东海县", "灌南县", "连云区", "海州区"],
    "淮安市": ["淮安区", "洪泽县", "金湖县", "盱眙县", "经济开发区", "清河区", "淮阴区", "清浦区", "涟水县"],
    "宿迁市": ["宿豫区", "泗洪县", "宿城区", "沭阳县", "泗阳县", "宿迁经济开发区"],
    "盐城市": ["东台市", "大丰区", "建湖县", "响水县", "阜宁县", "滨海县", "射阳县", "亭湖区", "盐都区"],
    "扬州市": ["广陵区", "邗江区", "宝应县", "仪征市", "高邮市", "江都区"],
    "泰州市": ["泰兴市", "靖江市", "兴化市", "高港区", "海陵区", "姜堰区"],
    "南通市": ["通州区", "如东县", "海安县", "港闸区", "崇川区", "南通经济技术开发区", "如皋市", "海门市", "启东市"],
    "镇江市": ["扬中市", "丹徒区", "润州区", "京口区", "镇江新区", "丹阳市", "句容市", "丹徒新区"],
    "常州市": ["金坛区", "溧阳市", "新北区", "钟楼区", "天宁区", "武进区"],
    "无锡市": ["崇安区", "南长区", "北塘区", "锡山区", "惠山区", "新区", "江阴市", "宜兴市", "滨湖区", "新吴区", "梁溪区"],
    "苏州市": ["常熟市", "张家港市", "相城区", "金阊区", "虎丘区", "平江区", "沧浪区", "工业园区", "高新区", "太仓市", "吴江区", "吴中区", "昆山市", "姑苏区"],
    "济南市": ["长清区", "平阴县", "济阳县", "商河县", "高新区", "历城区", "天桥区", "槐荫区", "历下区", "市中区", "章丘市"],
    "青岛市": ["莱西市", "四方区", "市北区", "市南区", "李沧区", "黄岛区", "即墨区", "城阳区", "崂山区", "胶州市", "平度市"],
    "淄博市": ["高青县", "沂源县", "桓台县", "周村区", "淄川区", "博山区", "临淄区", "张店区"],
    "枣庄市": ["山亭区", "台儿庄区", "峄城区", "薛城区", "市中区", "滕州市"],
    "东营市": ["河口区", "广饶县", "利津县", "垦利区", "东营区"],
    "潍坊市": ["青州市", "诸城市", "安丘市", "高密市", "昌邑市", "昌乐县", "临朐县", "坊子区", "潍城区", "奎文区", "高新区", "寒亭区", "寿光市"],
    "烟台市": ["莱阳市", "招远市", "蓬莱市", "栖霞市", "海阳市", "长岛县", "芝罘区", "莱山区", "福山区", "牟平区", "龙口市", "莱州市", "开发区"],
    "威海市": ["乳山市", "环翠区", "荣成市", "文登市"],
    "莱芜市": ["莱城区", "钢城区"],
    "德州市": ["乐陵市", "禹城市", "陵县", "宁津县", "武城县", "庆云县", "平原县", "临邑县", "夏津县", "德城区", "齐河县"],
    "临沂市": ["沂南县", "沂水县", "费县", "平邑县", "蒙阴县", "临沭县", "莒南县", "郯城县", "罗庄区", "兰山区", "河东区", "兰陵县"],
    "聊城市": ["临清市", "阳谷县", "茌平县", "莘县", "东阿县", "冠县", "高唐县", "东昌府区"],
    "滨州市": ["邹平县", "沾化县", "惠民县", "博兴县", "阳信县", "无棣县", "北海新区", "滨城区"],
    "菏泽市": ["单县", "曹县", "定陶县", "巨野县", "成武县", "东明县", "郓城县", "鄄城县", "牡丹区"],
    "日照市": ["五莲县", "莒县", "岚山区", "新市区", "东港区"],
    "泰安市": ["东平县", "宁阳县", "岱岳区", "泰山区", "肥城市", "新泰市"],
    "济宁市": ["梁山县", "兖州市", "微山县", "汶上县", "泗水县", "嘉祥县", "鱼台县", "金乡县", "任城区", "邹城市", "市中区", "曲阜市", "高新区"],
    "铜陵市": ["郊区", "义安区", "铜官区", "枞阳县"],
    "合肥市": ["肥东县", "庐江县", "包河区", "蜀山区", "瑶海区", "庐阳区", "经济技术开发区", "高新技术开发区", "北城新区", "滨湖新区", "政务文化新区", "新站综合开发试验区", "肥西县", "巢湖市", "长丰县"],
    "淮南市": ["凤台县", "田家庵区", "大通区", "谢家集区", "八公山区", "潘集区", "淮南高新技术开发区", "寿县"],
    "淮北市": ["杜集区", "烈山区", "濉溪县", "相山区"],
    "芜湖市": ["芜湖县", "繁昌县", "南陵县", "无为县", "镜湖区", "弋江区", "鸠江区", "三山区"],
    "蚌埠市": ["怀远县", "固镇县", "五河县", "蚌山区", "淮上区", "龙子湖区", "禹会区"],
    "马鞍山市": ["当涂县", "含山县", "和县", "博望区", "花山区", "雨山区"],
    "安庆市": ["桐城市", "宿松县", "太湖县", "怀宁县", "岳西县", "望江县", "潜山县", "大观区", "宜秀区", "迎江区"],
    "黄山市": ["休宁县", "歙县", "黟县", "祁门县", "黄山区", "徽州区", "屯溪区"],
    "滁州市": ["明光市", "全椒县", "来安县", "定远县", "凤阳县", "南谯区", "琅琊区", "天长市"],
    "阜阳市": ["界首市", "太和县", "阜南县", "颍上县", "临泉县", "经济开发区", "颍泉区", "颍州区", "颍东区"],
    "亳州市": ["利辛县", "蒙城县", "涡阳县", "谯城区"],
    "宿州市": ["灵璧县", "泗县", "萧县", "砀山县", "经济开发区", "埇桥区"],
    "池州市": ["东至县", "石台县", "青阳县", "贵池区"],
    "六安市": ["霍山县", "金寨县", "霍邱县", "舒城县", "金安区", "裕安区"],
    "宣城市": ["泾县", "旌德县", "宁国市", "郎溪县", "广德县", "绩溪县", "宣州区"],
    "宁波市": ["慈溪市", "奉化市", "宁海县", "象山县", "海曙区", "江东区", "高新科技开发区", "北仑区", "镇海区", "鄞州区", "江北区", "余姚市"],
    "杭州市": ["余杭区", "萧山区", "富阳区", "桐庐县", "建德市", "淳安县", "江干区", "滨江区", "上城区", "下城区", "拱墅区", "西湖区", "下沙区", "临安市"],
    "温州市": ["文成县", "平阳县", "泰顺县", "洞头区", "苍南县", "龙湾区", "茶山高教园区", "瑞安市", "乐清市", "鹿城区", "瓯海区", "永嘉县"],
    "嘉兴市": ["海宁市", "海盐县", "南湖区", "秀洲区", "桐乡市", "平湖市", "嘉善县"],
    "湖州市": ["长兴县", "德清县", "安吉县", "南浔区", "吴兴区"],
    "绍兴市": ["诸暨市", "上虞区", "嵊州市", "新昌县", "柯桥区", "越城区"],
    "金华市": ["金东区", "兰溪市", "婺城区", "义乌市", "东阳市", "永康市", "武义县", "浦江县", "磐安县"],
    "衢州市": ["江山市", "常山县", "开化县", "龙游县", "柯城区", "衢江区"],
    "丽水市": ["龙泉市", "缙云县", "遂昌县", "松阳县", "景宁县", "云和县", "青田县", "庆元县", "莲都区"],
    "台州市": ["临海市", "三门县", "天台县", "仙居县", "黄岩区", "椒江区", "路桥区", "温岭市", "玉环县"],
    "舟山市": ["岱山县", "嵊泗县", "普陀区", "定海区"],
    "福州市": ["长乐区", "平潭县", "连江县", "罗源县", "永泰县", "闽清县", "台江区", "鼓楼区", "晋安区", "仓山区", "马尾区", "福清市", "闽侯县"],
    "厦门市": ["思明区", "湖里区", "翔安区", "海沧区", "集美区", "同安区"],
    "三明市": ["永安市", "明溪县", "将乐县", "大田县", "宁化县", "建宁县", "沙县", "尤溪县", "清流县", "泰宁县", "梅列区", "三元区"],
    "莆田市": ["仙游县", "涵江区", "秀屿区", "城厢区", "荔城区"],
    "泉州市": ["石狮市", "南安市", "惠安县", "安溪县", "德化县", "永春县", "泉港区", "金门县", "洛江区", "鲤城区", "丰泽区", "晋江市"],
    "漳州市": ["龙海市", "平和县", "南靖县", "诏安县", "漳浦县", "华安县", "云霄县", "东山县", "长泰县", "芗城区", "龙文区"],
    "南平市": ["建瓯市", "邵武市", "武夷山市", "建阳市", "松溪县", "顺昌县", "浦城县", "政和县", "光泽县", "延平区"],
    "龙岩市": ["漳平市", "长汀县", "武平县", "永定县", "上杭县", "连城县", "新罗区"],
    "宁德市": ["福安市", "福鼎市", "寿宁县", "霞浦县", "柘荣县", "屏南县", "古田县", "周宁县", "蕉城区", "东侨开发区"],
    "武汉市": ["江岸区", "武昌区", "江汉区", "硚口区", "武汉经济技术开发区", "蔡甸区", "江夏区", "新洲区", "黄陂区", "汉阳区", "青山区", "洪山区", "汉南区", "东西湖区"],
    "黄石市": ["黄石港区", "铁山区", "大冶市", "阳新县", "下陆区", "西塞山区", "经济技术开发区"],
    "襄阳市": ["老河口市", "枣阳市", "宜城市", "南漳县", "保康县", "谷城县", "樊城区", "襄城区", "襄州区"],
    "十堰市": ["丹江口市", "房县", "竹山县", "竹溪县", "郧县", "郧西县", "茅箭区", "张湾区"],
    "荆州市": ["江陵县", "洪湖市", "石首市", "松滋市", "监利县", "公安县", "沙市区", "荆州区"],
    "宜昌市": ["当阳市", "枝江市", "夷陵区", "秭归县", "兴山县", "远安县", "五峰土家族自治县", "长阳土家族自治县", "宜都市", "猇亭区", "点军区", "伍家岗区", "西陵区"],
    "孝感市": ["汉川市", "云梦县", "大悟县", "孝昌县", "孝南区", "应城市", "安陆市"],
    "黄冈市": ["红安县", "罗田县", "黄梅县", "英山县", "团风县", "黄州区", "蕲春县", "麻城市", "武穴市", "浠水县"],
    "咸宁市": ["嘉鱼县", "通山县", "崇阳县", "通城县", "咸安区", "赤壁市"],
    "恩施州": ["恩施市", "利川市", "建始县", "来凤县", "巴东县", "鹤峰县", "宣恩县", "咸丰县"],
    "鄂州市": ["梁子湖区", "华容区", "鄂城区"],
    "荆门市": ["京山县", "钟祥市", "沙洋县", "掇刀区", "东宝区"],
    "随州市": ["广水市", "曾都区", "随县"],
    "潜江市": ["园林", "杨市", "周矶", "广华", "泰丰", "竹根滩镇", "高石碑镇", "积玉口镇", "渔洋镇", "王场镇", "熊口镇", "老新镇", "浩口镇", "张金镇", "龙湾镇", "江汉石油管理局", "潜江经济开发区", "西大垸管理区", "运粮湖管理区", "周矶管理区", "后湖管理区", "熊口管理区", "总口管理区", "高场原种场", "浩口原种场"],
    "天门市": ["侨乡街道开发区", "竟陵街道", "杨林街道", "佛子山镇", "多宝镇", "拖市镇", "张港镇", "蒋场镇", "汪场镇", "渔薪镇", "黄潭镇", "岳口镇", "横林镇", "彭市镇", "麻洋镇", "多祥镇", "干驿镇", "马湾镇", "卢市镇", "小板镇", "九真镇", "皂市镇", "胡市镇", "石河镇", "净潭乡", "蒋湖农场", "白茅湖农场", "沉湖管委会"],
    "仙桃市": ["郑场镇", "毛嘴镇", "豆河镇", "三伏潭镇", "胡场镇", "长埫口镇", "西流河镇", "沙湖镇", "杨林尾镇", "彭场镇", "张沟镇", "郭河镇", "沔城镇", "通海口镇", "陈场镇", "工业园区", "九合垸原种场", "沙湖原种场", "排湖渔场", "五湖渔场", "赵西垸林场", "刘家垸林场", "畜禽良种场", "城区"],
    "神农架林区": ["松柏镇", "阳日镇", "木鱼镇", "红坪镇", "新华镇", "宋洛乡", "九湖乡", "下谷坪乡"],
    "长沙市": ["望城区", "芙蓉区", "岳麓区", "雨花区", "开福区", "天心区", "浏阳市", "长沙县", "宁乡县"],
    "株洲市": ["醴陵市", "株洲县", "攸县", "茶陵县", "炎陵县", "天元区", "石峰区", "芦淞区", "荷塘区", "云龙示范区"],
    "湘潭市": ["湘乡市", "湘潭县", "韶山市", "雨湖区", "岳塘区"],
    "衡阳市": ["常宁市", "衡阳县", "耒阳市", "衡东县", "衡南县", "衡山县", "祁东县", "南岳区", "蒸湘区", "石鼓区", "珠晖区", "雁峰区"],
    "邵阳市": ["武冈市", "邵东县", "洞口县", "新邵县", "绥宁县", "新宁县", "邵阳县", "隆回县", "城步县", "大祥区", "双清区", "北塔区"],
    "岳阳市": ["临湘市", "汨罗市", "岳阳县", "湘阴县", "华容县", "平江县", "君山区", "云溪区", "岳阳楼区"],
    "常德市": ["津市市", "澧县", "临澧县", "桃源县", "汉寿县", "石门县", "安乡县", "鼎城区", "武陵区"],
    "张家界市": ["慈利县", "桑植县", "武陵源区", "永定区"],
    "郴州市": ["资兴市", "宜章县", "安仁县", "汝城县", "嘉禾县", "临武县", "桂东县", "永兴县", "桂阳县", "北湖区", "苏仙区"],
    "益阳市": ["南县", "桃江县", "安化县", "沅江市", "赫山区", "资阳区"],
    "永州市": ["祁阳县", "双牌县", "道县", "江永县", "江华县", "宁远县", "新田县", "蓝山县", "东安县", "零陵区", "冷水滩区"],
    "怀化市": ["洪江市", "会同县", "溆浦县", "辰溪县", "靖州县", "通道县", "芷江县", "新晃县", "麻阳县", "沅陵县", "中方县", "鹤城区"],
    "娄底市": ["冷水江市", "涟源市", "新化县", "双峰县", "娄星区"],
    "湘西州": ["吉首市", "古丈县", "龙山县", "永顺县", "泸溪县", "凤凰县", "花垣县", "保靖县"],
    "广州市": ["天河区", "海珠区", "荔湾区", "越秀区", "番禺区", "花都区", "白云区", "南沙区", "黄埔区", "增城区", "从化区", "广州大学城"],
    "深圳市": ["南山区", "罗湖区", "福田区", "宝安区", "光明新区", "坪山新区", "大鹏新区", "龙岗区", "盐田区", "龙华区"],
    "珠海市": ["斗门区", "金湾区", "香洲区"],
    "汕头市": ["南澳县", "龙湖区", "金平区", "澄海区", "潮阳区", "潮南区", "濠江区"],
    "韶关市": ["南雄市", "乐昌市", "仁化县", "始兴县", "翁源县", "新丰县", "乳源瑶族自治县", "曲江区", "武江区", "浈江区"],
    "河源市": ["和平县", "龙川县", "紫金县", "连平县", "源城区", "东源县"],
    "梅州市": ["兴宁市", "梅县", "蕉岭县", "大埔县", "丰顺县", "五华县", "平远县", "梅江区"],
    "惠州市": ["龙门县", "惠阳区", "大亚湾区", "惠城区", "惠东县", "博罗县"],
    "汕尾市": ["陆河县", "海丰县", "城区", "陆丰市"],
    "东莞市": ["中堂镇", "东坑镇", "道滘镇", "沙田镇", "高埗镇", "石龙镇", "石排镇", "企石镇", "石碣镇", "洪梅镇", "麻涌镇", "桥头镇", "望牛墩镇", "茶山镇", "谢岗镇", "松山湖", "莞城区", "南城区", "长安镇", "寮步镇", "大岭山镇", "常平镇", "厚街镇", "万江区", "樟木头镇", "大朗镇", "塘厦镇", "凤岗镇", "清溪镇", "横沥镇", "东城区", "黄江镇", "虎门镇"],
    "中山市": ["南朗镇", "小榄镇", "古镇", "坦洲镇", "黄圃镇", "三乡镇", "东凤镇", "横栏镇", "三角镇", "南头镇", "沙溪镇", "五桂山镇", "阜沙镇", "东升镇", "板芙镇", "神湾镇", "港口镇", "大涌镇", "火炬开发区", "民众镇", "沙朗镇", "城区"],
    "江门市": ["台山市", "新会区", "鹤山市", "江海区", "蓬江区", "开平市", "恩平市"],
    "佛山市": ["顺德区", "禅城区", "高明区", "三水区", "南海区"],
    "阳江市": ["阳春市", "阳西县", "江城区", "阳东县"],
    "湛江市": ["雷州市", "吴川市", "徐闻县", "坡头区", "赤坎区", "霞山区", "经济技术开发区", "麻章区", "遂溪县", "廉江市"],
    "茂名市": ["信宜市", "茂南区", "电白区", "高州市", "化州市"],
    "肇庆市": ["广宁县", "德庆县", "怀集县", "封开县", "鼎湖区", "端州区", "四会市", "高要市"],
    "云浮市": ["云安县", "新兴县", "郁南县", "云城区", "罗定市"],
    "清远市": ["连州市", "佛冈县", "阳山县", "清新县", "连山县", "连南县", "清城区", "英德市"],
    "潮州市": ["饶平县", "枫溪区", "湘桥区", "潮安区"],
    "揭阳市": ["揭西县", "惠来县", "东山区", "普宁市", "榕城区", "揭东县"],
    "南宁市": ["武鸣区", "邕宁区", "宾阳县", "横县", "上林县", "隆安县", "马山县", "良庆区", "江南区", "兴宁区", "青秀区", "西乡塘区"],
    "柳州市": ["柳江县", "柳城县", "鹿寨县", "融安县", "三江县", "融水县", "鱼峰区", "城中区", "柳南区", "柳北区"],
    "桂林市": ["阳朔县", "临桂县", "灵川县", "全州县", "平乐县", "兴安县", "灌阳县", "荔浦县", "资源县", "永福县", "龙胜县", "恭城县", "象山区", "雁山区", "秀峰区", "叠彩区", "七星区"],
    "梧州市": ["岑溪市", "苍梧县", "藤县", "蒙山县", "万秀区", "蝶山区", "长洲区", "龙圩区"],
    "北海市": ["合浦县", "铁山港区", "海城区", "银海区"],
    "防城港市": ["东兴市", "上思县", "防城区", "港口区"],
    "钦州市": ["浦北县", "灵山县", "钦北区", "钦南区"],
    "贵港市": ["桂平市", "平南县", "覃塘区", "港南区", "港北区"],
    "玉林市": ["北流市", "容县", "博白县", "陆川县", "兴业县", "玉州区"],
    "贺州市": ["钟山县", "昭平县", "富川县", "平桂管理区", "八步区"],
    "百色市": ["右江区", "平果县", "乐业县", "田阳县", "西林县", "田林县", "德保县", "靖西县", "田东县", "那坡县", "隆林县", "凌云县"],
    "河池市": ["宜州市", "天峨县", "凤山县", "南丹县", "东兰县", "巴马县", "环江县", "罗城县", "大化县", "都安县", "金城江区"],
    "来宾市": ["兴宾区", "合山市", "忻城县", "武宣县", "象州县", "金秀县"],
    "崇左市": ["江州区", "凭祥市", "扶绥县", "大新县", "天等县", "宁明县", "龙州县"],
    "南昌市": ["南昌县", "进贤县", "安义县", "新建县", "湾里区", "青云谱区", "西湖区", "东湖区", "高新区", "昌北区", "青山湖区", "红谷滩新区"],
    "景德镇市": ["乐平市", "浮梁县", "珠山区", "昌江区"],
    "萍乡市": ["湘东区", "莲花县", "上栗县", "芦溪县", "安源区"],
    "新余市": ["分宜县", "渝水区"],
    "九江市": ["柴桑区", "瑞昌市", "庐山市", "武宁县", "彭泽县", "永修县", "修水县", "湖口县", "德安县", "都昌县", "共青城市", "经济技术开发区", "八里湖新区", "庐山风景名胜区", "濂溪区", "浔阳区"],
    "鹰潭市": ["余江县", "贵溪市", "月湖区", "龙虎山风景旅游区"],
    "上饶市": ["德兴市", "广丰县", "鄱阳县", "婺源县", "余干县", "横峰县", "弋阳县", "铅山县", "玉山县", "万年县", "信州区", "上饶县"],
    "宜春市": ["丰城市", "樟树市", "高安市", "铜鼓县", "靖安县", "宜丰县", "奉新县", "万载县", "上高县", "袁州区"],
    "抚州市": ["南丰县", "乐安县", "金溪县", "南城县", "东乡县", "资溪县", "宜黄县", "崇仁县", "黎川县", "广昌县", "临川区"],
    "吉安市": ["井冈山市", "吉安县", "永丰县", "永新县", "新干县", "泰和县", "峡江县", "遂川县", "安福县", "吉水县", "万安县", "青原区", "吉州区"],
    "赣州市": ["南康市", "瑞金市", "石城县", "安远县", "赣县", "宁都县", "寻乌县", "兴国县", "定南县", "上犹县", "于都县", "龙南县", "崇义县", "大余县", "信丰县", "全南县", "会昌县", "章贡区"],
    "成都市": ["高新西区", "新都区", "温江区", "龙泉驿区", "青白江区", "彭州市", "崇州市", "邛崃市", "都江堰市", "郫都区", "新津县", "双流区", "大邑县", "蒲江县", "金堂县", "青羊区", "锦江区", "金牛区", "武侯区", "成华区", "高新区"],
    "自贡市": ["荣县", "富顺县", "自流井区", "沿滩区", "大安区", "贡井区"],
    "攀枝花市": ["米易县", "盐边县", "仁和区", "西区", "东区"],
    "泸州市": ["泸县", "合江县", "叙永县", "古蔺县", "纳溪区", "江阳区", "龙马潭区"],
    "绵阳市": ["盐亭县", "三台县", "平武县", "北川县", "安州区", "梓潼县", "江油市", "涪城区", "游仙区", "高新区", "经开区"],
    "德阳市": ["罗江县", "中江县", "广汉市", "什邡市", "旌阳区", "绵竹市"],
    "广元市": ["青川县", "旺苍县", "剑阁县", "苍溪县", "昭化区", "朝天区", "利州区"],
    "遂宁市": ["射洪县", "蓬溪县", "大英县", "安居区", "船山区"],
    "内江市": ["资中县", "隆昌县", "威远县", "市中区", "东兴区"],
    "乐山市": ["五通桥区", "沙湾区", "金口河区", "夹江县", "井研县", "犍为县", "沐川县", "峨边县", "马边县", "市中区", "峨眉山市"],
    "宜宾市": ["宜宾县", "南溪区", "江安县", "长宁县", "兴文县", "珙县", "高县", "屏山县", "筠连县", "翠屏区"],
    "广安市": ["岳池县", "武胜县", "邻水县", "广安区", "华蓥市", "前锋区"],
    "南充市": ["仪陇县", "蓬安县", "营山县", "南部县", "顺庆区", "高坪区", "嘉陵区", "西充县", "阆中市"],
    "达州市": ["通川区", "达川区", "大竹县", "渠县", "万源市", "宣汉县", "开江县"],
    "巴中市": ["南江县", "平昌县", "通江县", "巴州区", "恩阳区"],
    "雅安市": ["芦山县", "石棉县", "名山区", "天全县", "荥经县", "汉源县", "宝兴县", "雨城区"],
    "眉山市": ["仁寿县", "彭山区", "洪雅县", "丹棱县", "青神县", "东坡区"],
    "资阳市": ["安岳县", "乐至县", "雁江区", "简阳市"],
    "阿坝州": ["马尔康市", "九寨沟县", "红原县", "阿坝县", "理县", "若尔盖县", "金川县", "小金县", "黑水县", "松潘县", "壤塘县", "茂县", "汶川县"],
    "甘孜州": ["康定市", "泸定县", "九龙县", "丹巴县", "道孚县", "炉霍县", "色达县", "甘孜县", "新龙县", "白玉县", "德格县", "石渠县", "雅江县", "理塘县", "巴塘县", "稻城县", "乡城县", "得荣县"],
    "凉山州": ["美姑县", "昭觉县", "会理县", "会东县", "普格县", "宁南县", "德昌县", "冕宁县", "盐源县", "金阳县", "布拖县", "雷波县", "越西县", "喜德县", "甘洛县", "木里县", "西昌市"],
    "海口市": ["秀英区", "龙华区", "琼山区", "美兰区"],
    "儋州市": ["那大镇", "和庆镇", "南丰镇", "大成镇", "雅星镇", "兰洋镇", "光村镇", "木棠镇", "海头镇", "峨蔓镇", "三都镇", "王五镇", "白马井镇", "中和镇", "排浦镇", "东成镇", "新州镇", "洋浦经济开发区", "富克镇", "西培农场", "西联农场", "蓝洋农场", "八一农场", "西华农场", "西庆农场", "西流农场", "新盈农场", "龙山农场", "红岭农场", "热作学院"],
    "琼海市": ["嘉积镇", "万泉镇", "石壁镇", "中原镇", "博鳌镇", "阳江镇", "龙江镇", "潭门镇", "塔洋镇", "长坡镇", "大路镇", "会山镇", "彬村山华侨农场", "东太农场", "东红农场", "东升农场", "南俸农场"],
    "万宁市": ["万城镇", "龙滚镇", "和乐镇", "后安镇", "大茂镇", "东澳镇", "礼纪镇", "长丰镇", "山根镇", "北大镇", "南桥镇", "三更罗镇", "六连林场", "东兴农场", "东和农场", "新中农场", "兴隆华侨农场", "兴隆镇", "南林农场"],
    "东方市": ["八所镇", "东河镇", "大田镇", "感城镇", "板桥镇", "三家镇", "四更镇", "新龙镇", "天安乡", "江边乡", "广坝农场", "东方华侨农场"],
    "三亚市": ["海棠区", "吉阳区", "天涯区", "崖州区"],
    "文昌市": ["文城镇", "重兴镇", "蓬莱镇", "会文镇", "东路镇", "潭牛镇", "东阁镇", "文教镇", "东郊镇", "龙楼镇", "昌洒镇", "翁田镇", "抱罗镇", "冯坡镇", "锦山镇", "铺前镇", "公坡镇", "迈号镇", "清谰镇", "南阳镇", "新桥镇", "头苑镇", "宝芳乡", "龙马乡", "湖山乡", "东路农场", "南阳农场", "罗豆农场", "橡胶研究所"],
    "五指山市": ["通什镇", "南圣镇", "毛阳镇", "番阳镇", "畅好乡", "毛道乡", "水满乡", "畅好农场"],
    "临高县": ["临城镇", "波莲镇", "东英镇", "博厚镇", "皇桐镇", "多文镇", "和舍镇", "南宝镇", "新盈镇", "调楼镇", "加来镇", "红华农场", "加来农场", "城区"],
    "澄迈县": ["金江镇", "老城镇", "瑞溪镇", "永发镇", "加乐镇", "文儒镇", "中兴镇", "仁兴镇", "福山镇", "桥头镇", "大丰镇", "红光农场", "西达农场", "金安农场", "城区"],
    "定安县": ["定城镇", "新竹镇", "龙湖镇", "雷鸣镇", "龙门镇", "龙河镇", "岭口镇", "翰林镇", "富文镇", "黄竹镇", "金鸡岭农场", "中瑞农场", "南海农场", "城区"],
    "屯昌县": ["屯城镇", "新兴镇", "枫木镇", "乌坡镇", "南吕镇", "南坤镇", "坡心镇", "西昌镇", "中建农场", "中坤农场", "县城内"],
    "昌江县": ["石碌镇", "叉河镇", "十月田镇", "乌烈镇", "昌化镇", "海尾镇", "七叉镇", "王下乡", "海南矿业公司", "霸王岭林场", "红林农场", "城区"],
    "白沙县": ["牙叉镇", "七坊镇", "邦溪镇", "打安镇", "细水乡", "元门乡", "南开乡", "阜龙乡", "青松乡", "金波乡", "荣邦乡", "白沙农场", "龙江农场", "邦溪农场", "城区"],
    "琼中县": ["营根镇", "湾岭镇", "黎母山镇", "和平镇", "长征镇", "红毛镇", "中平镇", "上安乡", "什运乡", "吊罗山乡", "黎母山林业公司", "阳江农场", "乌石农场", "加钗农场", "长征农场", "城区"],
    "陵水县": ["椰林镇", "光坡镇", "三才镇", "英州镇", "隆广镇", "文罗镇", "本号镇", "新村镇", "黎安镇", "提蒙乡", "群英乡", "吊罗山林业公司", "岭门农场", "南平农场", "城区", "东华镇", "南平镇"],
    "保亭县": ["保城镇", "什玲镇", "加茂镇", "响水镇", "新政镇", "三道镇", "六弓乡", "南林乡", "毛感乡", "保亭研究所", "新星农场", "金江农场", "三道农场"],
    "乐东县": ["抱由镇", "万冲镇", "大安镇", "志仲镇", "千家镇", "九所镇", "利国镇", "黄流镇", "佛罗镇", "尖峰镇", "莺歌海镇", "尖峰岭林业公司", "莺歌海盐场", "山荣农场", "乐光农场", "保国农场", "城区"],
    "三沙市": ["西沙群岛", "南沙群岛", "中沙群岛"],
    "贵阳市": ["清镇市", "开阳县", "修文县", "息烽县", "乌当区", "南明区", "白云区", "云岩区", "花溪区", "小河区", "观山湖区"],
    "六盘水市": ["盘县", "六枝特区", "水城县", "钟山区"],
    "遵义市": ["赤水市", "仁怀市", "播州区", "桐梓县", "绥阳县", "习水县", "凤冈县", "正安县", "湄潭县", "余庆县", "道真县", "务川县", "红花岗区", "汇川区"],
    "铜仁市": ["碧江区", "德江县", "江口县", "思南县", "万山区", "石阡县", "玉屏侗族自治县", "松桃苗族自治县", "印江土家族苗族自治县", "沿河土家族自治县"],
    "毕节市": ["黔西县", "大方县", "织金县", "金沙县", "赫章县", "纳雍县", "威宁彝族回族苗族自治县", "七星关区"],
    "安顺市": ["西秀区", "普定县", "平坝区", "镇宁布依族苗族自治县", "关岭布依族苗族自治县", "紫云苗族布依族自治县"],
    "黔西南州": ["兴义市", "望谟县", "兴仁县", "普安县", "册亨县", "晴隆县", "贞丰县", "安龙县"],
    "黔东南州": ["凯里市", "施秉县", "从江县", "锦屏县", "镇远县", "麻江县", "台江县", "天柱县", "黄平县", "榕江县", "剑河县", "三穗县", "雷山县", "黎平县", "岑巩县", "丹寨县"],
    "黔南州": ["都匀市", "福泉市", "贵定县", "惠水县", "罗甸县", "瓮安县", "荔波县", "龙里县", "平塘县", "长顺县", "独山县", "三都县"],
    "昆明市": ["东川区", "安宁市", "富民县", "嵩明县", "晋宁区", "宜良县", "禄劝县", "石林县", "寻甸县", "盘龙区", "五华区", "官渡区", "西山区", "呈贡区"],
    "曲靖市": ["马龙县", "宣威市", "富源县", "会泽县", "陆良县", "师宗县", "罗平县", "沾益区", "麒麟区"],
    "玉溪市": ["红塔区", "华宁县", "澄江县", "易门县", "通海县", "江川区", "元江县", "新平县", "峨山县"],
    "昭通市": ["昭阳区", "镇雄县", "永善县", "大关县", "盐津县", "彝良县", "水富县", "巧家县", "威信县", "鲁甸县", "绥江县"],
    "普洱市": ["思茅区", "宁洱县", "景东县", "镇沅县", "景谷县", "墨江县", "澜沧县", "西盟县", "江城县", "孟连县"],
    "临沧市": ["临翔区", "镇康县", "凤庆县", "云县", "永德县", "耿马县", "双江县", "沧源县"],
    "保山市": ["隆阳区", "施甸县", "昌宁县", "龙陵县", "腾冲市"],
    "丽江市": ["玉龙县", "华坪县", "永胜县", "宁蒗县", "古城区"],
    "文山州": ["文山市", "麻栗坡县", "砚山县", "广南县", "马关县", "富宁县", "西畴县", "丘北县"],
    "红河州": ["个旧市", "开远市", "弥勒市", "红河县", "绿春县", "蒙自市", "泸西县", "建水县", "元阳县", "石屏县", "金平县", "屏边县", "河口县"],
    "西双版纳州": ["景洪市", "勐海县", "勐腊县"],
    "楚雄州": ["元谋县", "南华县", "牟定县", "武定县", "大姚县", "双柏县", "禄丰县", "永仁县", "姚安县", "楚雄市"],
    "大理州": ["剑川县", "弥渡县", "云龙县", "洱源县", "鹤庆县", "宾川县", "祥云县", "永平县", "巍山县", "漾濞县", "南涧县", "大理市"],
    "德宏州": ["芒市", "瑞丽市", "盈江县", "梁河县", "陇川县"],
    "怒江州": ["泸水市", "福贡县", "兰坪县", "贡山县"],
    "迪庆州": ["香格里拉市", "德钦县", "维西县"],
    "拉萨市": ["城关区", "林周县", "当雄县", "尼木县", "曲水县", "堆龙德庆区", "达孜县", "墨竹工卡县"],
    "那曲地区": ["索县", "那曲县", "嘉黎县", "比如县", "聂荣县", "安多县", "申扎县", "班戈县", "巴青县", "尼玛县", "双湖县"],
    "山南地区": ["贡嘎县", "扎囊县", "乃东区", "桑日县", "琼结县", "曲松县", "措美县", "洛扎县", "加查县", "隆子县", "错那县", "浪卡子县"],
    "昌都地区": ["卡若区", "江达县", "贡觉县", "类乌齐县", "丁青县", "察雅县", "八宿县", "左贡县", "芒康县", "洛隆县", "边坝县"],
    "日喀则地区": ["聂拉木县", "昂仁县", "桑珠孜区", "南木林县", "江孜县", "定日县", "萨迦县　", "拉孜县", "谢通门县", "白朗县", "仁布县", "康马县", "定结县", "仲巴县", "亚东县", "吉隆县", "萨嘎县", "岗巴县"],
    "阿里地区": ["噶尔县", "普兰县", "札达县　", "日土县", "革吉县", "改则县", "措勤县"],
    "林芝市": ["巴宜区", "工布江达县", "米林县", "墨脱县", "波密县", "察隅县", "朗县"],
    "西安市": ["高陵县", "蓝田县", "户县", "周至县", "雁塔区", "未央区", "长安区", "灞桥区", "碑林区", "莲湖区", "临潼区", "阎良区", "新城区", "西安武警工程学院"],
    "铜川市": ["印台区", "宜君县", "王益区", "耀州区"],
    "宝鸡市": ["岐山县", "太白县", "凤翔县", "陇县", "麟游县", "千阳县", "扶风县", "凤县", "眉县", "渭滨区", "金台区", "陈仓区"],
    "咸阳市": ["兴平市", "礼泉县", "泾阳县", "永寿县", "三原县", "彬县", "旬邑县", "长武县", "乾县", "武功县", "淳化县", "秦都区", "渭城区", "杨陵区"],
    "渭南市": ["韩城市", "华阴市", "蒲城县", "华县", "潼关县", "大荔县", "澄城县", "合阳县", "白水县", "富平县", "临渭区"],
    "延安市": ["安塞县", "洛川县", "子长县", "黄陵县", "延长县", "宜川县", "延川县", "甘泉县", "富县", "志丹县", "黄龙县", "吴起县", "宝塔区"],
    "汉中市": ["南郑县", "城固县", "洋县", "佛坪县", "留坝县", "镇巴县", "西乡县", "勉县", "略阳县", "宁强县", "汉台区", "经济开发区南区"],
    "榆林市": ["清涧县", "绥德县", "佳县", "神木市", "府谷县", "子洲县", "横山县", "米脂县", "吴堡县", "定边县", "靖边县", "榆阳区"],
    "商洛市": ["商州区", "镇安县", "山阳县", "洛南县", "商南县", "丹凤县", "柞水县"],
    "安康市": ["紫阳县", "岚皋县", "旬阳县", "镇坪县", "平利县", "宁陕县", "汉阴县", "石泉县", "白河县", "汉滨区"],
    "兰州市": ["永登县", "榆中县", "皋兰县", "西固区", "红古区", "七里河区", "安宁区", "城关区"],
    "金昌市": ["永昌县", "金川区"],
    "白银市": ["白银区", "平川区", "靖远县", "景泰县", "会宁县"],
    "天水市": ["甘谷县", "武山县", "清水县", "秦安县", "张家川县", "麦积区", "秦州区"],
    "嘉峪关市": ["雄关区", "长城区", "镜铁区"],
    "平凉市": ["华亭县", "崇信县", "泾川县", "灵台县", "庄浪县", "崆峒区", "静宁县"],
    "庆阳市": ["西峰区", "镇原县", "合水县", "华池县", "环县", "宁县", "正宁县", "庆城县"],
    "陇南市": ["成县", "礼县", "康县", "武都区", "文县", "两当县", "徽县", "宕昌县", "西和县"],
    "武威市": ["凉州区", "古浪县", "天祝县", "民勤县"],
    "张掖市": ["甘州区", "山丹县", "临泽县", "高台县", "肃南县", "民乐县"],
    "酒泉市": ["玉门市", "敦煌市", "金塔县", "阿克塞县", "肃北县", "瓜州县", "肃州区"],
    "甘南州": ["合作市", "夏河县", "碌曲县", "舟曲县", "玛曲县", "迭部县", "临潭县", "卓尼县"],
    "临夏州": ["临夏县", "康乐县", "永靖县", "和政县", "东乡族自治县", "积石山县", "临夏市", "广河县"],
    "定西市": ["岷县", "安定区", "通渭县", "临洮县", "漳县", "渭源县", "陇西县"],
    "西宁市": ["湟中县", "湟源县", "大通县", "城中区", "城东区", "城西区", "城北区"],
    "海东地区": ["平安县", "乐都县", "民和县", "互助县", "化隆县", "循化县"],
    "海北州": ["海晏县", "祁连县", "刚察县", "门源县"],
    "黄南州": ["尖扎县", "同仁县", "泽库县", "河南县"],
    "海南州": ["共和县", "同德县", "贵德县", "兴海县", "贵南县"],
    "果洛州": ["玛沁县", "甘德县", "达日县", "班玛县", "久治县", "玛多县"],
    "玉树州": ["玉树县", "称多县", "囊谦县", "杂多县", "治多县", "曲麻莱县"],
    "海西州": ["德令哈市", "乌兰县", "天峻县", "都兰县", "大柴旦行委", "冷湖行委", "茫崖行委", "格尔木市"],
    "银川市": ["灵武市", "永宁县", "贺兰县", "兴庆区", "金凤区", "西夏区"],
    "石嘴山市": ["平罗县", "惠农区", "大武口区"],
    "吴忠市": ["青铜峡市", "同心县", "盐池县", "红寺堡开发区", "利通区"],
    "固原市": ["西吉县", "隆德县", "泾源县", "彭阳县", "原州区"],
    "中卫市": ["中宁县", "海原县", "沙坡头区"],
    "乌鲁木齐市": ["乌鲁木齐县", "头屯河区", "达坂城区", "米东区", "天山区", "新市区", "沙依巴克区", "水磨沟区"],
    "克拉玛依市": ["克拉玛依区", "独山子区", "白碱滩区", "乌尔禾区"],
    "石河子市": ["石河子市"],
    "吐鲁番地区": ["吐鲁番市", "托克逊县", "鄯善县"],
    "哈密地区": ["哈密市", "巴里坤县", "伊吾县"],
    "和田地区": ["和田市", "墨玉县", "洛浦县", "策勒县", "于田县", "民丰县", "皮山县", "和田县"],
    "阿克苏地区": ["阿克苏市", "温宿县", "沙雅县", "拜城县", "阿瓦提县", "库车县", "柯坪县", "新和县", "乌什县"],
    "喀什地区": ["喀什市", "巴楚县", "泽普县", "伽师县", "叶城县", "岳普湖县", "疏附县", "疏勒县", "英吉沙县", "麦盖提县", "莎车县", "塔什库尔干县"],
    "克孜勒苏柯尔克孜自治州": ["阿图什市", "阿合奇县", "乌恰县", "阿克陶县"],
    "巴音郭楞州": ["库尔勒市", "尉犁县", "和静县", "博湖县", "和硕县", "轮台县", "若羌县", "且末县", "焉耆县"],
    "昌吉州": ["昌吉市", "阜康市", "奇台县", "玛纳斯县", "吉木萨尔县", "呼图壁县", "木垒县"],
    "博尔塔拉州": ["博乐市", "精河县", "温泉县", "阿拉山口市"],
    "伊犁州": ["伊宁市", "特克斯县", "尼勒克县", "昭苏县", "新源县", "霍城县", "察布查尔县", "巩留县", "奎屯市", "伊宁县", "霍尔果斯市"],
    "塔城地区": ["塔城市", "乌苏市", "额敏县", "裕民县", "沙湾县", "托里县", "和布克赛尔县"],
    "阿勒泰地区": ["阿勒泰市", "富蕴县", "青河县", "吉木乃县", "布尔津县", "福海县", "哈巴河县", "北屯市"],
    "五家渠市": ["五家渠市"],
    "阿拉尔市": ["阿拉尔市"],
    "图木舒克市": ["图木舒克市"],
    "铁门关市": ["铁门关市"],
    "昆玉市": ["昆玉市"],
    "台湾": ["彰化", "嘉义", "新竹", "花莲", "宜兰", "高雄", "基隆", "金门", "连江", "苗栗", "南投", "澎湖", "屏东", "台东", "台中", "台南", "台北", "桃园", "云林", "新北"],
    "钓鱼岛": ["钓鱼岛县", "钓鱼岛县1", "钓鱼岛全区"],
    "香港特别行政区": ["中西区", "东区", "九龙城区", "观塘区", "深水埗区", "湾仔区", "黄大仙区", "油尖旺区", "离岛区", "葵青区", "北区", "西贡区", "沙田区", "屯门区", "大埔区", "荃湾区", "元朗区", "香港", "九龙", "新界"],
    "澳门特别行政区": ["澳门特别行政区", "澳门半岛", "凼仔", "路凼城", "路环"],
  },
  "regionID": {
    "北京": 1,
    "上海": 2,
    "天津": 3,
    "重庆": 4,
    "河北": 5,
    "山西": 6,
    "河南": 7,
    "辽宁": 8,
    "吉林": 9,
    "黑龙江": 10,
    "内蒙古": 11,
    "江苏": 12,
    "山东": 13,
    "安徽": 14,
    "浙江": 15,
    "福建": 16,
    "湖北": 17,
    "湖南": 18,
    "广东": 19,
    "广西": 20,
    "江西": 21,
    "四川": 22,
    "海南": 23,
    "贵州": 24,
    "云南": 25,
    "西藏": 26,
    "陕西": 27,
    "甘肃": 28,
    "青海": 29,
    "宁夏": 30,
    "新疆": 31,
    "台湾": 32,
    "钓鱼岛": 84,
    "港澳": 52993,
    "保税区": 10000004,
    "亚洲": 10000006,
    "欧洲": 10000007,
    "非洲": 10000008,
    "北美洲": 10000009,
    "南美洲": 10000010,
    "大洋洲": 10000011,
    "南极洲": 10000012,
    "辛集市": 143,
    "晋州市": 145,
    "新乐市": 146,
    "井陉县": 153,
    "栾城县": 154,
    "行唐县": 156,
    "灵寿县": 157,
    "高邑县": 158,
    "赵县": 159,
    "赞皇县": 160,
    "深泽县": 161,
    "无极县": 162,
    "元氏县": 163,
    "井陉矿区": 3182,
    "平山县": 4158,
    "藁城市": 42540,
    "鹿泉市": 42541,
    "正定县": 42542,
    "新华区": 42543,
    "桥西区": 42544,
    "桥东区": 42545,
    "裕华区": 42546,
    "长安区": 42547,
    "邯郸县": 167,
    "峰峰矿区": 168,
    "曲周县": 169,
    "馆陶县": 170,
    "魏县": 171,
    "成安县": 172,
    "大名县": 173,
    "涉县": 174,
    "鸡泽县": 175,
    "邱县": 176,
    "广平县": 177,
    "肥乡县": 178,
    "磁县": 180,
    "临漳县": 3077,
    "永年县": 3187,
    "丛台区": 34049,
    "邯山区": 34050,
    "复兴区": 34051,
    "武安市": 34052,
    "邢台县": 183,
    "南宫市": 184,
    "沙河市": 185,
    "柏乡县": 186,
    "任县": 187,
    "清河县": 188,
    "隆尧县": 189,
    "临城县": 190,
    "广宗县": 191,
    "临西县": 192,
    "内丘县": 193,
    "平乡县": 194,
    "巨鹿县": 195,
    "新河县": 196,
    "南和县": 197,
    "宁晋县": 257,
    "威县": 3098,
    "桥西区": 47712,
    "桥东区": 47713,
    "安国市": 203,
    "满城县": 205,
    "清苑县": 206,
    "涞水县": 207,
    "阜平县": 208,
    "定兴县": 210,
    "唐县": 211,
    "高阳县": 212,
    "容城县": 213,
    "涞源县": 214,
    "望都县": 215,
    "易县": 217,
    "曲阳县": 218,
    "蠡县": 219,
    "顺平县": 220,
    "博野县": 221,
    "雄县": 222,
    "新市区": 3190,
    "北市区": 3191,
    "南市区": 3192,
    "安新县": 3193,
    "涿州市": 47213,
    "定州市": 47214,
    "徐水县": 47215,
    "高碑店市": 47216,
    "宣化县": 225,
    "康保县": 226,
    "张北县": 227,
    "阳原县": 228,
    "赤城县": 229,
    "怀安县": 230,
    "怀来县": 231,
    "崇礼县": 232,
    "尚义县": 233,
    "蔚县": 234,
    "涿鹿县": 235,
    "万全县": 236,
    "下花园区": 238,
    "沽源县": 3156,
    "宣化区": 4046,
    "桥西区": 34298,
    "桥东区": 34299,
    "兴隆县": 241,
    "平泉市": 242,
    "滦平县": 243,
    "丰宁县": 245,
    "围场县": 246,
    "宽城县": 247,
    "隆化县": 2767,
    "承德县": 3092,
    "双滦区": 3197,
    "鹰手营子矿区": 3198,
    "双桥区": 48379,
    "卢龙县": 261,
    "青龙县": 262,
    "昌黎县": 263,
    "北戴河区": 2990,
    "抚宁县": 4093,
    "海港区": 48377,
    "山海关区": 48378,
    "遵化市": 2756,
    "丰南区": 2757,
    "迁西县": 2759,
    "滦南县": 2760,
    "玉田县": 2762,
    "曹妃甸区": 2763,
    "乐亭县": 2764,
    "滦县": 2765,
    "古冶区": 3202,
    "开平区": 3203,
    "路北区": 41497,
    "路南区": 41499,
    "迁安市": 41500,
    "丰润区": 41502,
    "沧县": 265,
    "泊头市": 266,
    "河间市": 268,
    "献县": 269,
    "肃宁县": 270,
    "青县": 271,
    "东光县": 272,
    "吴桥县": 273,
    "南皮县": 276,
    "盐山县": 277,
    "海兴县": 278,
    "孟村县": 279,
    "运河区": 49576,
    "新华区": 49577,
    "任丘市": 49578,
    "黄骅市": 49579,
    "固安县": 284,
    "永清县": 285,
    "香河县": 286,
    "大城县": 287,
    "文安县": 288,
    "大厂县": 289,
    "安次区": 3206,
    "广阳区": 3207,
    "开发区": 4097,
    "三河市": 49707,
    "霸州市": 49708,
    "冀州市": 291,
    "深州市": 292,
    "饶阳县": 293,
    "枣强县": 294,
    "故城县": 295,
    "阜城县": 296,
    "安平县": 297,
    "武邑县": 298,
    "景县": 299,
    "武强县": 300,
    "桃城区": 41510,
    "阳曲县": 304,
    "古交市": 305,
    "娄烦县": 306,
    "清徐县": 307,
    "小店区": 36780,
    "迎泽区": 36781,
    "晋源区": 36782,
    "万柏林区": 36783,
    "尖草坪区": 36784,
    "杏花岭区": 36785,
    "大同县": 310,
    "天镇县": 311,
    "灵丘县": 312,
    "阳高县": 313,
    "左云县": 314,
    "浑源县": 315,
    "广灵县": 316,
    "新荣区": 3214,
    "南郊区": 3216,
    "矿区": 3217,
    "城区": 32061,
    "盂县": 319,
    "平定县": 320,
    "郊区": 321,
    "矿区": 3219,
    "城区": 44144,
    "高平市": 326,
    "阳城县": 327,
    "沁水县": 328,
    "陵川县": 329,
    "泽州县": 2967,
    "城区": 3073,
    "山阴县": 331,
    "右玉县": 332,
    "应县": 333,
    "怀仁县": 334,
    "朔城区": 335,
    "平鲁区": 3118,
    "介休市": 338,
    "昔阳县": 339,
    "祁县": 341,
    "左权县": 342,
    "寿阳县": 343,
    "太谷县": 344,
    "和顺县": 345,
    "灵石县": 346,
    "平遥县": 347,
    "榆社县": 348,
    "榆次区": 44145,
    "原平市": 351,
    "代县": 352,
    "神池县": 353,
    "五寨县": 354,
    "五台县": 358,
    "偏关县": 359,
    "宁武县": 360,
    "静乐县": 361,
    "繁峙县": 362,
    "河曲县": 363,
    "保德县": 364,
    "定襄县": 365,
    "忻府区": 366,
    "岢岚县": 367,
    "离石区": 369,
    "孝义市": 370,
    "汾阳市": 371,
    "文水县": 372,
    "中阳县": 373,
    "兴县": 374,
    "临县": 375,
    "方山县": 376,
    "柳林县": 377,
    "岚县": 378,
    "交口县": 3235,
    "交城县": 3236,
    "石楼县": 3237,
    "侯马市": 380,
    "霍州市": 381,
    "汾西县": 382,
    "吉县": 383,
    "安泽县": 384,
    "浮山县": 386,
    "大宁县": 387,
    "古县": 388,
    "隰县": 389,
    "襄汾县": 390,
    "翼城县": 391,
    "永和县": 392,
    "乡宁县": 393,
    "洪洞县": 395,
    "蒲县": 396,
    "曲沃县": 3136,
    "尧都区": 32206,
    "河津市": 399,
    "永济市": 400,
    "新绛县": 402,
    "平陆县": 403,
    "垣曲县": 404,
    "绛县": 405,
    "稷山县": 406,
    "芮城县": 407,
    "夏县": 408,
    "临猗县": 409,
    "万荣县": 410,
    "闻喜县": 3233,
    "盐湖区": 32360,
    "长治县": 3075,
    "潞城市": 3109,
    "郊区": 3222,
    "襄垣县": 3223,
    "屯留县": 3224,
    "平顺县": 3225,
    "黎城县": 3226,
    "壶关县": 3227,
    "长子县": 3228,
    "武乡县": 3229,
    "沁县": 3230,
    "沁源县": 3231,
    "城区": 32505,
    "新密市": 415,
    "登封市": 416,
    "上街区": 2782,
    "惠济区": 3544,
    "金水区": 3545,
    "管城区": 3546,
    "二七区": 3547,
    "中原区": 3548,
    "郑东新区": 4337,
    "新郑市": 46820,
    "巩义市": 46821,
    "荥阳市": 46822,
    "中牟县": 46823,
    "经济开发区": 47300,
    "高新技术开发区": 47301,
    "开封县": 421,
    "杞县": 422,
    "兰考县": 423,
    "尉氏县": 425,
    "通许县": 3127,
    "金明区": 45533,
    "龙亭区": 45534,
    "顺河区": 45535,
    "鼓楼区": 45536,
    "禹王台区": 45537,
    "偃师市": 428,
    "孟津县": 429,
    "汝阳县": 430,
    "伊川县": 431,
    "洛宁县": 432,
    "宜阳县": 434,
    "栾川县": 435,
    "新安县": 436,
    "吉利区": 3555,
    "涧西区": 3556,
    "瀍河区": 3557,
    "老城区": 3558,
    "西工区": 3559,
    "嵩县": 4150,
    "伊滨区": 45531,
    "洛龙区": 45532,
    "汝州市": 439,
    "舞钢市": 440,
    "郏县": 441,
    "叶县": 442,
    "鲁山县": 443,
    "宝丰县": 444,
    "石龙区": 3560,
    "湛河区": 35965,
    "卫东区": 35966,
    "新华区": 35967,
    "沁阳市": 447,
    "孟州市": 448,
    "修武县": 449,
    "温县": 450,
    "武陟县": 451,
    "博爱县": 452,
    "山阳区": 453,
    "解放区": 3566,
    "马村区": 37371,
    "中站区": 37372,
    "浚县": 455,
    "淇县": 456,
    "鹤山区": 457,
    "山城区": 3567,
    "淇滨区": 35591,
    "卫辉市": 459,
    "辉县市": 460,
    "新乡县": 461,
    "获嘉县": 462,
    "原阳县": 463,
    "长垣县": 464,
    "延津县": 465,
    "封丘县": 466,
    "凤泉区": 3570,
    "牧野区": 37456,
    "红旗区": 37457,
    "卫滨区": 37458,
    "林州市": 469,
    "安阳县": 470,
    "滑县": 471,
    "汤阴县": 472,
    "内黄县": 473,
    "龙安区": 35470,
    "殷都区": 35471,
    "文峰区": 35472,
    "开发区": 35473,
    "北关区": 35474,
    "濮阳县": 476,
    "南乐县": 477,
    "台前县": 478,
    "清丰县": 479,
    "范县": 480,
    "华龙区": 481,
    "禹州市": 483,
    "长葛市": 484,
    "建安区": 485,
    "鄢陵县": 486,
    "襄城县": 487,
    "魏都区": 488,
    "郾城区": 490,
    "临颍县": 492,
    "召陵区": 493,
    "舞阳县": 494,
    "源汇区": 3576,
    "义马市": 496,
    "灵宝市": 497,
    "陕县": 498,
    "卢氏县": 499,
    "渑池县": 3113,
    "湖滨区": 35637,
    "邓州市": 503,
    "桐柏县": 504,
    "方城县": 505,
    "淅川县": 506,
    "镇平县": 507,
    "唐河县": 508,
    "南召县": 509,
    "内乡县": 510,
    "新野县": 511,
    "社旗县": 512,
    "西峡县": 515,
    "卧龙区": 35751,
    "宛城区": 35752,
    "永城市": 518,
    "宁陵县": 519,
    "虞城县": 520,
    "民权县": 521,
    "夏邑县": 522,
    "柘城县": 523,
    "睢县": 524,
    "睢阳区": 34751,
    "梁园区": 34752,
    "项城市": 529,
    "商水县": 530,
    "淮阳县": 531,
    "太康县": 532,
    "鹿邑县": 533,
    "西华县": 534,
    "扶沟县": 535,
    "沈丘县": 536,
    "郸城县": 537,
    "东新区": 34926,
    "经济开发区": 34927,
    "川汇区": 35108,
    "确山县": 540,
    "新蔡县": 541,
    "上蔡县": 542,
    "泌阳县": 543,
    "西平县": 544,
    "遂平县": 545,
    "汝南县": 546,
    "平舆县": 547,
    "正阳县": 548,
    "驿城区": 35189,
    "潢川县": 551,
    "淮滨县": 552,
    "息县": 553,
    "新县": 554,
    "固始县": 556,
    "罗山县": 557,
    "光山县": 558,
    "商城县": 3119,
    "平桥区": 34548,
    "浉河区": 34549,
    "五龙口镇": 35178,
    "下冶镇": 35179,
    "轵城镇": 35180,
    "王屋镇": 35181,
    "思礼镇": 35182,
    "邵原镇": 35183,
    "坡头镇": 35184,
    "梨林镇": 35185,
    "克井镇": 35186,
    "大峪镇": 35187,
    "承留镇": 35188,
    "城区": 52305,
    "苏家屯区": 567,
    "新民市": 569,
    "法库县": 570,
    "辽中县": 571,
    "康平县": 572,
    "皇姑区": 50819,
    "铁西区": 50820,
    "大东区": 50821,
    "沈河区": 50822,
    "东陵区": 50823,
    "于洪区": 50824,
    "和平区": 50825,
    "浑南新区": 50826,
    "沈北新区": 50827,
    "普兰店市": 574,
    "瓦房店市": 575,
    "庄河市": 576,
    "长海县": 577,
    "沙河口区": 3261,
    "西岗区": 3263,
    "中山区": 4468,
    "甘井子区": 5909,
    "高新园区": 6561,
    "大连开发区": 6627,
    "金州区": 46824,
    "旅顺口区": 46825,
    "台安县": 580,
    "海城市": 581,
    "岫岩县": 583,
    "铁东区": 3264,
    "立山区": 3266,
    "铁西区": 37581,
    "千山区": 37582,
    "抚顺县": 585,
    "新宾县": 586,
    "清原县": 587,
    "望花区": 3268,
    "东洲区": 3269,
    "新抚区": 3270,
    "顺城区": 3271,
    "桓仁县": 591,
    "南芬区": 3275,
    "本溪县": 41341,
    "平山区": 41342,
    "溪湖区": 41343,
    "明山区": 41344,
    "宽甸县": 596,
    "元宝区": 20171,
    "振兴区": 20172,
    "振安区": 20173,
    "东港市": 20174,
    "凤城市": 20175,
    "义县": 599,
    "凌海市": 600,
    "北镇市": 601,
    "黑山县": 602,
    "古塔区": 4912,
    "凌河区": 4913,
    "太和区": 4914,
    "经济技术开发区": 6790,
    "绥中县": 606,
    "建昌县": 607,
    "南票区": 608,
    "龙港区": 3300,
    "连山区": 20524,
    "兴城市": 20525,
    "大石桥市": 610,
    "盖州市": 611,
    "老边区": 3282,
    "西市区": 3283,
    "站前区": 6628,
    "鲅鱼圈区": 20183,
    "盘山县": 614,
    "大洼县": 615,
    "兴隆台区": 20661,
    "双台子区": 20662,
    "阜新县": 618,
    "彰武县": 619,
    "清河门区": 3286,
    "新邱区": 3288,
    "海州区": 20658,
    "太平区": 20659,
    "细河区": 20660,
    "辽阳县": 623,
    "太子河区": 3290,
    "弓长岭区": 3291,
    "宏伟区": 3292,
    "白塔区": 43963,
    "文圣区": 43964,
    "灯塔市": 43965,
    "凌源市": 633,
    "北票市": 634,
    "喀喇沁左翼县": 635,
    "朝阳县": 636,
    "建平县": 637,
    "龙城区": 3299,
    "双塔区": 20348,
    "银州区": 6859,
    "清河区": 6860,
    "开原市": 6862,
    "铁岭县": 6863,
    "西丰县": 6864,
    "昌图县": 6865,
    "调兵山市": 44027,
    "榆树市": 640,
    "九台市": 641,
    "农安县": 642,
    "德惠市": 3172,
    "双阳区": 3306,
    "朝阳区": 38630,
    "南关区": 38631,
    "宽城区": 38632,
    "二道区": 38633,
    "绿园区": 38634,
    "净月区": 38635,
    "汽车产业开发区": 38636,
    "高新技术开发区": 38637,
    "经济技术开发区": 38638,
    "舒兰市": 645,
    "桦甸市": 646,
    "蛟河市": 647,
    "磐石市": 648,
    "永吉县": 649,
    "昌邑区": 24069,
    "龙潭区": 24070,
    "船营区": 24071,
    "丰满区": 24072,
    "公主岭市": 652,
    "双辽市": 653,
    "梨树县": 654,
    "伊通县": 656,
    "铁东区": 6641,
    "铁西区": 6642,
    "梅河口市": 658,
    "集安市": 659,
    "通化县": 660,
    "辉南县": 661,
    "柳河县": 662,
    "二道江区": 663,
    "东昌区": 3311,
    "临江市": 665,
    "江源区": 669,
    "靖宇县": 671,
    "抚松县": 672,
    "长白县": 673,
    "浑江区": 24074,
    "乾安县": 675,
    "长岭县": 676,
    "扶余县": 677,
    "宁江区": 24075,
    "前郭县": 24076,
    "大安市": 682,
    "洮南市": 683,
    "通榆县": 684,
    "镇赉县": 685,
    "洮北区": 686,
    "图们市": 3312,
    "敦化市": 3313,
    "珲春市": 3314,
    "龙井市": 3315,
    "和龙市": 3316,
    "汪清县": 3317,
    "安图县": 3318,
    "延吉市": 24073,
    "龙山区": 2993,
    "西安区": 2994,
    "东丰县": 2995,
    "东辽县": 2996,
    "阿城区": 699,
    "尚志市": 700,
    "双城市": 701,
    "五常市": 702,
    "方正县": 704,
    "宾县": 705,
    "依兰县": 706,
    "巴彦县": 707,
    "通河县": 708,
    "木兰县": 709,
    "延寿县": 710,
    "呼兰区": 45814,
    "松北区": 45815,
    "道里区": 45816,
    "南岗区": 45817,
    "道外区": 45818,
    "香坊区": 45819,
    "平房区": 45820,
    "梅里斯区": 713,
    "昂昂溪区": 714,
    "富拉尔基区": 715,
    "碾子山区": 716,
    "讷河市": 717,
    "富裕县": 718,
    "拜泉县": 719,
    "甘南县": 720,
    "依安县": 721,
    "克山县": 722,
    "龙江县": 723,
    "克东县": 724,
    "泰来县": 725,
    "建华区": 33404,
    "龙沙区": 33405,
    "铁锋区": 33406,
    "萝北县": 728,
    "绥滨县": 729,
    "兴山区": 3334,
    "向阳区": 3335,
    "工农区": 3336,
    "南山区": 3337,
    "兴安区": 3338,
    "东山区": 3339,
    "集贤县": 733,
    "宝清县": 734,
    "友谊县": 735,
    "饶河县": 736,
    "尖山区": 3340,
    "岭东区": 3341,
    "四方台区": 3342,
    "宝山区": 3343,
    "密山市": 739,
    "虎林市": 740,
    "鸡东县": 741,
    "恒山区": 3329,
    "滴道区": 3330,
    "梨树区": 3331,
    "城子河区": 3332,
    "麻山区": 3333,
    "鸡冠区": 33163,
    "萨尔图区": 744,
    "龙凤区": 745,
    "让胡路区": 746,
    "红岗区": 747,
    "大同区": 748,
    "林甸县": 749,
    "肇州县": 750,
    "肇源县": 751,
    "杜尔伯特县": 752,
    "铁力市": 754,
    "嘉荫县": 755,
    "伊春区": 3344,
    "南岔区": 3345,
    "友好区": 3346,
    "西林区": 3347,
    "翠峦区": 3348,
    "新青区": 3349,
    "美溪区": 3350,
    "金山屯区": 3351,
    "五营区": 3352,
    "乌马河区": 3353,
    "汤旺河区": 3354,
    "带岭区": 3355,
    "乌伊岭区": 3356,
    "红星区": 3357,
    "上甘岭区": 3358,
    "海林市": 758,
    "宁安市": 760,
    "穆棱市": 761,
    "林口县": 762,
    "东宁县": 763,
    "爱民区": 3367,
    "东安区": 3368,
    "阳明区": 3369,
    "西安区": 3370,
    "绥芬河市": 4148,
    "同江市": 766,
    "富锦市": 767,
    "桦川县": 768,
    "抚远县": 769,
    "桦南县": 770,
    "汤原县": 771,
    "前进区": 33269,
    "向阳区": 33270,
    "东风区": 33271,
    "郊区": 33272,
    "勃利县": 774,
    "桃山区": 3364,
    "新兴区": 3365,
    "茄子河区": 3366,
    "金沙新区": 53287,
    "北安市": 777,
    "五大连池市": 778,
    "逊克县": 779,
    "孙吴县": 780,
    "嫩江县": 3096,
    "爱辉区": 3371,
    "安达市": 784,
    "肇东市": 785,
    "海伦市": 786,
    "绥棱县": 787,
    "兰西县": 788,
    "明水县": 789,
    "青冈县": 790,
    "庆安县": 791,
    "望奎县": 792,
    "北林区": 6712,
    "呼玛县": 794,
    "塔河县": 795,
    "漠河县": 796,
    "加格达奇区": 4114,
    "松岭区": 4115,
    "呼中区": 4116,
    "新林区": 11432,
    "土默特左旗": 801,
    "和林格尔县": 802,
    "武川县": 803,
    "托克托县": 804,
    "清水河县": 3133,
    "玉泉区": 3240,
    "赛罕区": 3241,
    "回民区": 32652,
    "新城区": 32653,
    "固阳县": 807,
    "土默特右旗": 808,
    "达茂联合旗": 809,
    "石拐区": 3245,
    "白云矿区": 3246,
    "东河区": 38251,
    "九原区": 38252,
    "青山区": 38253,
    "昆都仑区": 38254,
    "海勃湾区": 811,
    "海南区": 3248,
    "乌达区": 3249,
    "宁城县": 814,
    "敖汉旗": 815,
    "喀喇沁旗": 816,
    "翁牛特旗": 817,
    "巴林右旗": 818,
    "林西县": 819,
    "克什克腾旗": 820,
    "巴林左旗": 821,
    "阿鲁科尔沁旗": 822,
    "元宝山区": 3199,
    "松山区": 3251,
    "红山区": 32937,
    "集宁区": 824,
    "丰镇市": 825,
    "兴和县": 826,
    "卓资县": 827,
    "商都县": 828,
    "凉城县": 829,
    "化德县": 830,
    "察哈尔右翼前旗": 831,
    "察哈尔右翼中旗": 832,
    "察哈尔右翼后旗": 833,
    "四子王旗": 834,
    "锡林浩特市": 836,
    "二连浩特市": 837,
    "多伦县": 838,
    "阿巴嘎旗": 839,
    "西乌珠穆沁旗": 840,
    "东乌珠穆沁旗": 841,
    "苏尼特右旗": 842,
    "苏尼特左旗": 843,
    "太仆寺旗": 844,
    "正镶白旗": 845,
    "正蓝旗": 846,
    "镶黄旗": 847,
    "海拉尔区": 849,
    "满洲里市": 850,
    "牙克石市": 851,
    "扎兰屯市": 852,
    "根河市": 853,
    "额尔古纳市": 854,
    "陈巴尔虎旗": 855,
    "阿荣旗": 856,
    "新巴尔虎左旗": 857,
    "新巴尔虎右旗": 858,
    "鄂伦春旗": 859,
    "莫力达瓦旗": 860,
    "鄂温克族旗": 861,
    "东胜区": 871,
    "准格尔旗": 872,
    "伊金霍洛旗": 874,
    "乌审旗": 875,
    "杭锦旗": 876,
    "鄂托克旗": 877,
    "鄂托克前旗": 878,
    "达拉特旗": 879,
    "康巴什新区": 18374,
    "临河区": 881,
    "五原县": 882,
    "磴口县": 883,
    "杭锦后旗": 884,
    "乌拉特中旗": 885,
    "乌拉特后旗 ": 888,
    "乌拉特前旗": 890,
    "阿拉善右旗": 892,
    "阿拉善左旗": 893,
    "额济纳旗": 894,
    "乌兰浩特市": 896,
    "阿尔山市": 897,
    "突泉县": 898,
    "扎赉特旗": 899,
    "科尔沁右翼前旗": 900,
    "科尔沁右翼中旗": 901,
    "霍林郭勒市": 3142,
    "开鲁县": 3252,
    "库伦旗": 3253,
    "奈曼旗": 3254,
    "扎鲁特旗": 3255,
    "科尔沁左翼中旗": 3256,
    "科尔沁左翼后旗": 3258,
    "科尔沁区": 32769,
    "江宁区": 905,
    "高淳区": 907,
    "六合区": 908,
    "溧水区": 3024,
    "玄武区": 3373,
    "秦淮区": 3375,
    "建邺区": 3376,
    "鼓楼区": 3377,
    "栖霞区": 3378,
    "雨花台区": 3379,
    "浦口区": 50647,
    "铜山区": 914,
    "睢宁县": 915,
    "沛县": 916,
    "丰县": 917,
    "贾汪区": 3388,
    "金山桥开发区": 4223,
    "铜山经济技术开发区": 4224,
    "八段工业园区": 4228,
    "鼓楼区": 23686,
    "邳州市": 23687,
    "泉山区": 23688,
    "新沂市": 23689,
    "云龙区": 23690,
    "赣榆区": 920,
    "灌云县": 921,
    "东海县": 922,
    "灌南县": 923,
    "连云区": 4248,
    "海州区": 23684,
    "淮安区": 926,
    "洪泽县": 929,
    "金湖县": 930,
    "盱眙县": 931,
    "经济开发区": 4305,
    "清河区": 36560,
    "淮阴区": 36561,
    "清浦区": 36562,
    "涟水县": 36563,
    "宿豫区": 934,
    "泗洪县": 937,
    "宿城区": 3407,
    "沭阳县": 8558,
    "泗阳县": 8559,
    "宿迁经济开发区": 40649,
    "东台市": 940,
    "大丰区": 941,
    "建湖县": 945,
    "响水县": 946,
    "阜宁县": 948,
    "滨海县": 949,
    "射阳县": 23681,
    "亭湖区": 23682,
    "盐都区": 23683,
    "广陵区": 955,
    "邗江区": 956,
    "宝应县": 957,
    "仪征市": 42218,
    "高邮市": 42219,
    "江都区": 42220,
    "泰兴市": 960,
    "靖江市": 962,
    "兴化市": 963,
    "高港区": 3405,
    "海陵区": 3406,
    "姜堰区": 40174,
    "通州区": 967,
    "如东县": 970,
    "海安县": 2774,
    "港闸区": 3394,
    "崇川区": 3395,
    "南通经济技术开发区": 4385,
    "如皋市": 38364,
    "海门市": 38365,
    "启东市": 38366,
    "扬中市": 973,
    "丹徒区": 976,
    "润州区": 3403,
    "京口区": 3404,
    "镇江新区": 4916,
    "丹阳市": 38517,
    "句容市": 38518,
    "丹徒新区": 51180,
    "金坛区": 980,
    "溧阳市": 981,
    "新北区": 2927,
    "钟楼区": 3392,
    "天宁区": 3393,
    "武进区": 4459,
    "崇安区": 3381,
    "南长区": 3382,
    "北塘区": 3383,
    "锡山区": 3384,
    "惠山区": 3385,
    "新区": 4029,
    "江阴市": 13989,
    "宜兴市": 15943,
    "滨湖区": 40035,
    "新吴区": 53561,
    "梁溪区": 53562,
    "常熟市": 993,
    "张家港市": 994,
    "相城区": 3082,
    "金阊区": 3083,
    "虎丘区": 3085,
    "平江区": 3087,
    "沧浪区": 3088,
    "工业园区": 3444,
    "高新区": 3742,
    "太仓市": 4346,
    "吴江区": 39628,
    "吴中区": 40034,
    "昆山市": 47821,
    "姑苏区": 53563,
    "长清区": 1002,
    "平阴县": 1003,
    "济阳县": 1004,
    "商河县": 1005,
    "高新区": 4277,
    "历城区": 40488,
    "天桥区": 40489,
    "槐荫区": 40490,
    "历下区": 40491,
    "市中区": 40492,
    "章丘市": 40493,
    "莱西市": 1014,
    "四方区": 3519,
    "市北区": 3520,
    "市南区": 3521,
    "李沧区": 4909,
    "黄岛区": 5505,
    "即墨区": 37916,
    "城阳区": 37917,
    "崂山区": 37918,
    "胶州市": 37919,
    "平度市": 37920,
    "高青县": 1019,
    "沂源县": 1020,
    "桓台县": 1021,
    "周村区": 2924,
    "淄川区": 2962,
    "博山区": 2968,
    "临淄区": 2969,
    "张店区": 47166,
    "山亭区": 3522,
    "台儿庄区": 3523,
    "峄城区": 3524,
    "薛城区": 3525,
    "市中区": 3526,
    "滕州市": 28932,
    "河口区": 1026,
    "广饶县": 1027,
    "利津县": 1028,
    "垦利区": 1029,
    "东营区": 36884,
    "青州市": 1033,
    "诸城市": 1034,
    "安丘市": 1036,
    "高密市": 1037,
    "昌邑市": 1038,
    "昌乐县": 1039,
    "临朐县": 1041,
    "坊子区": 3530,
    "潍城区": 28921,
    "奎文区": 28922,
    "高新区": 28923,
    "寒亭区": 28924,
    "寿光市": 28925,
    "莱阳市": 1044,
    "招远市": 1047,
    "蓬莱市": 1048,
    "栖霞市": 1049,
    "海阳市": 1050,
    "长岛县": 1051,
    "芝罘区": 3126,
    "莱山区": 3528,
    "福山区": 46504,
    "牟平区": 46505,
    "龙口市": 46506,
    "莱州市": 46507,
    "开发区": 51029,
    "乳山市": 1054,
    "环翠区": 28926,
    "荣成市": 28928,
    "文登市": 28929,
    "莱城区": 1059,
    "钢城区": 3539,
    "乐陵市": 1061,
    "禹城市": 1062,
    "陵县": 1063,
    "宁津县": 1064,
    "武城县": 1066,
    "庆云县": 1067,
    "平原县": 1068,
    "临邑县": 1069,
    "夏津县": 1071,
    "德城区": 3542,
    "齐河县": 25879,
    "沂南县": 1073,
    "沂水县": 1074,
    "费县": 1076,
    "平邑县": 1077,
    "蒙阴县": 1078,
    "临沭县": 1079,
    "莒南县": 2926,
    "郯城县": 2974,
    "罗庄区": 3540,
    "兰山区": 28930,
    "河东区": 28931,
    "兰陵县": 52023,
    "临清市": 1082,
    "阳谷县": 1084,
    "茌平县": 1085,
    "莘县": 1086,
    "东阿县": 1087,
    "冠县": 1088,
    "高唐县": 4043,
    "东昌府区": 25880,
    "邹平县": 1092,
    "沾化县": 1093,
    "惠民县": 1094,
    "博兴县": 1095,
    "阳信县": 1096,
    "无棣县": 2772,
    "北海新区": 25877,
    "滨城区": 25878,
    "单县": 1101,
    "曹县": 1102,
    "定陶县": 1103,
    "巨野县": 1104,
    "成武县": 1105,
    "东明县": 1106,
    "郓城县": 1107,
    "鄄城县": 2773,
    "牡丹区": 3543,
    "五莲县": 2934,
    "莒县": 3068,
    "岚山区": 4113,
    "新市区": 4196,
    "东港区": 28920,
    "东平县": 3132,
    "宁阳县": 3535,
    "岱岳区": 46665,
    "泰山区": 46666,
    "肥城市": 46667,
    "新泰市": 46668,
    "梁山县": 2908,
    "兖州市": 2910,
    "微山县": 2912,
    "汶上县": 2913,
    "泗水县": 2914,
    "嘉祥县": 2915,
    "鱼台县": 2916,
    "金乡县": 2917,
    "任城区": 3533,
    "邹城市": 25713,
    "市中区": 25714,
    "曲阜市": 25715,
    "高新区": 25728,
    "郊区": 19784,
    "义安区": 19786,
    "铜官区": 52830,
    "枞阳县": 52832,
    "肥东县": 1119,
    "庐江县": 1190,
    "包河区": 3431,
    "蜀山区": 3432,
    "瑶海区": 3433,
    "庐阳区": 3434,
    "经济技术开发区": 4173,
    "高新技术开发区": 4192,
    "北城新区": 6117,
    "滨湖新区": 6118,
    "政务文化新区": 6119,
    "新站综合开发试验区": 6120,
    "肥西县": 36173,
    "巢湖市": 49709,
    "长丰县": 49710,
    "凤台县": 1122,
    "田家庵区": 3447,
    "大通区": 3448,
    "谢家集区": 3449,
    "八公山区": 3450,
    "潘集区": 3451,
    "淮南高新技术开发区": 4960,
    "寿县": 52831,
    "杜集区": 19223,
    "烈山区": 19224,
    "濉溪县": 19225,
    "相山区": 19226,
    "芜湖县": 1128,
    "繁昌县": 1129,
    "南陵县": 1130,
    "无为县": 1189,
    "镜湖区": 3438,
    "弋江区": 4172,
    "鸠江区": 49137,
    "三山区": 49138,
    "怀远县": 1133,
    "固镇县": 1134,
    "五河县": 1135,
    "蚌山区": 3442,
    "淮上区": 18549,
    "龙子湖区": 18550,
    "禹会区": 18551,
    "当涂县": 1138,
    "含山县": 1187,
    "和县": 1188,
    "博望区": 6963,
    "花山区": 49253,
    "雨山区": 49254,
    "桐城市": 1141,
    "宿松县": 1142,
    "太湖县": 1144,
    "怀宁县": 1145,
    "岳西县": 1146,
    "望江县": 1147,
    "潜山县": 1148,
    "大观区": 18375,
    "宜秀区": 18376,
    "迎江区": 18377,
    "休宁县": 1153,
    "歙县": 1154,
    "黟县": 1155,
    "祁门县": 1156,
    "黄山区": 3464,
    "徽州区": 19227,
    "屯溪区": 19228,
    "明光市": 1161,
    "全椒县": 1162,
    "来安县": 1163,
    "定远县": 1164,
    "凤阳县": 1165,
    "南谯区": 3467,
    "琅琊区": 18715,
    "天长市": 18716,
    "界首市": 1168,
    "太和县": 1169,
    "阜南县": 1170,
    "颍上县": 1171,
    "临泉县": 1172,
    "经济开发区": 4832,
    "颍泉区": 19158,
    "颍州区": 19159,
    "颍东区": 19160,
    "利辛县": 1176,
    "蒙城县": 1177,
    "涡阳县": 1178,
    "谯城区": 18627,
    "灵璧县": 1181,
    "泗县": 1182,
    "萧县": 1183,
    "砀山县": 1184,
    "经济开发区": 6006,
    "埇桥区": 19575,
    "东至县": 1202,
    "石台县": 1203,
    "青阳县": 1204,
    "贵池区": 18714,
    "霍山县": 1208,
    "金寨县": 1209,
    "霍邱县": 1210,
    "舒城县": 1211,
    "金安区": 18912,
    "裕安区": 18913,
    "泾县": 2972,
    "旌德县": 3128,
    "宁国市": 3147,
    "郎溪县": 3477,
    "广德县": 3478,
    "绩溪县": 3479,
    "宣州区": 19684,
    "慈溪市": 1224,
    "奉化市": 1226,
    "宁海县": 1227,
    "象山县": 1228,
    "海曙区": 3412,
    "江东区": 3413,
    "高新科技开发区": 4253,
    "北仑区": 46341,
    "镇海区": 46342,
    "鄞州区": 46343,
    "江北区": 46344,
    "余姚市": 46345,
    "余杭区": 1214,
    "萧山区": 1215,
    "富阳区": 1217,
    "桐庐县": 1218,
    "建德市": 1219,
    "淳安县": 1220,
    "江干区": 2963,
    "滨江区": 3038,
    "上城区": 3408,
    "下城区": 3409,
    "拱墅区": 3410,
    "西湖区": 3411,
    "下沙区": 4285,
    "临安市": 49711,
    "文成县": 1237,
    "平阳县": 1238,
    "泰顺县": 1239,
    "洞头区": 1240,
    "苍南县": 1241,
    "龙湾区": 3416,
    "茶山高教园区": 4342,
    "瑞安市": 42321,
    "乐清市": 42322,
    "鹿城区": 42323,
    "瓯海区": 42324,
    "永嘉县": 42325,
    "海宁市": 1244,
    "海盐县": 1248,
    "南湖区": 3418,
    "秀洲区": 3419,
    "桐乡市": 4429,
    "平湖市": 4430,
    "嘉善县": 4431,
    "长兴县": 1251,
    "德清县": 1252,
    "安吉县": 1253,
    "南浔区": 4130,
    "吴兴区": 44189,
    "诸暨市": 1257,
    "上虞区": 1258,
    "嵊州市": 1259,
    "新昌县": 1260,
    "柯桥区": 15944,
    "越城区": 44188,
    "金东区": 1263,
    "兰溪市": 1264,
    "婺城区": 1265,
    "义乌市": 1266,
    "东阳市": 1267,
    "永康市": 1268,
    "武义县": 1269,
    "浦江县": 1270,
    "磐安县": 1271,
    "江山市": 1275,
    "常山县": 1276,
    "开化县": 1277,
    "龙游县": 1278,
    "柯城区": 22044,
    "衢江区": 22045,
    "龙泉市": 1281,
    "缙云县": 1282,
    "遂昌县": 1283,
    "松阳县": 1284,
    "景宁县": 1285,
    "云和县": 1286,
    "青田县": 1288,
    "庆元县": 3045,
    "莲都区": 22043,
    "临海市": 1291,
    "三门县": 1294,
    "天台县": 1295,
    "仙居县": 1296,
    "黄岩区": 22046,
    "椒江区": 22047,
    "路桥区": 22048,
    "温岭市": 22049,
    "玉环县": 22050,
    "岱山县": 1300,
    "嵊泗县": 1301,
    "普陀区": 42565,
    "定海区": 42566,
    "长乐区": 1305,
    "平潭县": 1308,
    "连江县": 1309,
    "罗源县": 1312,
    "永泰县": 1313,
    "闽清县": 1314,
    "台江区": 3483,
    "鼓楼区": 3484,
    "晋安区": 48712,
    "仓山区": 48713,
    "马尾区": 48714,
    "福清市": 48715,
    "闽侯县": 48716,
    "思明区": 1316,
    "湖里区": 3486,
    "翔安区": 3489,
    "海沧区": 46763,
    "集美区": 46764,
    "同安区": 46765,
    "永安市": 1319,
    "明溪县": 1320,
    "将乐县": 1321,
    "大田县": 1322,
    "宁化县": 1323,
    "建宁县": 1324,
    "沙县": 1325,
    "尤溪县": 1326,
    "清流县": 1327,
    "泰宁县": 1328,
    "梅列区": 22463,
    "三元区": 22464,
    "仙游县": 1331,
    "涵江区": 3022,
    "秀屿区": 3492,
    "城厢区": 46146,
    "荔城区": 46147,
    "石狮市": 1334,
    "南安市": 1336,
    "惠安县": 1337,
    "安溪县": 1338,
    "德化县": 1339,
    "永春县": 1340,
    "泉港区": 3117,
    "金门县": 3495,
    "洛江区": 3498,
    "鲤城区": 42930,
    "丰泽区": 42931,
    "晋江市": 42932,
    "龙海市": 1343,
    "平和县": 1344,
    "南靖县": 1345,
    "诏安县": 1346,
    "漳浦县": 1347,
    "华安县": 1348,
    "云霄县": 1349,
    "东山县": 1350,
    "长泰县": 1351,
    "芗城区": 3499,
    "龙文区": 3500,
    "建瓯市": 1354,
    "邵武市": 1355,
    "武夷山市": 1356,
    "建阳市": 1357,
    "松溪县": 1358,
    "顺昌县": 1359,
    "浦城县": 1360,
    "政和县": 1361,
    "光泽县": 2956,
    "延平区": 22465,
    "漳平市": 1364,
    "长汀县": 1365,
    "武平县": 1366,
    "永定县": 1367,
    "上杭县": 1368,
    "连城县": 1369,
    "新罗区": 44319,
    "福安市": 1372,
    "福鼎市": 1373,
    "寿宁县": 1374,
    "霞浦县": 1375,
    "柘荣县": 1376,
    "屏南县": 1377,
    "古田县": 1378,
    "周宁县": 1379,
    "蕉城区": 46145,
    "东侨开发区": 46164,
    "江岸区": 1386,
    "武昌区": 3079,
    "江汉区": 3582,
    "硚口区": 3583,
    "武汉经济技术开发区": 4424,
    "蔡甸区": 50712,
    "江夏区": 50713,
    "新洲区": 50714,
    "黄陂区": 50715,
    "汉阳区": 50716,
    "青山区": 50717,
    "洪山区": 50718,
    "汉南区": 50719,
    "东西湖区": 50720,
    "黄石港区": 1389,
    "铁山区": 1392,
    "大冶市": 1393,
    "阳新县": 1394,
    "下陆区": 43272,
    "西塞山区": 43273,
    "经济技术开发区": 43291,
    "老河口市": 1397,
    "枣阳市": 1398,
    "宜城市": 1399,
    "南漳县": 1401,
    "保康县": 1402,
    "谷城县": 1403,
    "樊城区": 23282,
    "襄城区": 23283,
    "襄州区": 23284,
    "丹江口市": 1406,
    "房县": 1407,
    "竹山县": 1408,
    "竹溪县": 1409,
    "郧县": 1410,
    "郧西县": 1411,
    "茅箭区": 23429,
    "张湾区": 23430,
    "江陵县": 1414,
    "洪湖市": 1415,
    "石首市": 1416,
    "松滋市": 1417,
    "监利县": 1418,
    "公安县": 1419,
    "沙市区": 3593,
    "荆州区": 4078,
    "当阳市": 1423,
    "枝江市": 1424,
    "夷陵区": 1425,
    "秭归县": 1426,
    "兴山县": 1427,
    "远安县": 1428,
    "五峰土家族自治县": 1429,
    "长阳土家族自治县": 1430,
    "宜都市": 3594,
    "猇亭区": 3595,
    "点军区": 3596,
    "伍家岗区": 3597,
    "西陵区": 3598,
    "汉川市": 1435,
    "云梦县": 1437,
    "大悟县": 1438,
    "孝昌县": 1439,
    "孝南区": 45215,
    "应城市": 45216,
    "安陆市": 45217,
    "红安县": 1444,
    "罗田县": 1445,
    "黄梅县": 1447,
    "英山县": 1448,
    "团风县": 1449,
    "黄州区": 41908,
    "蕲春县": 41909,
    "麻城市": 41910,
    "武穴市": 41911,
    "浠水县": 41912,
    "嘉鱼县": 1461,
    "通山县": 1462,
    "崇阳县": 1463,
    "通城县": 1464,
    "咸安区": 43387,
    "赤壁市": 43388,
    "恩施市": 1467,
    "利川市": 1468,
    "建始县": 1469,
    "来凤县": 1470,
    "巴东县": 1471,
    "鹤峰县": 1472,
    "宣恩县": 1473,
    "咸丰县": 1474,
    "梁子湖区": 3601,
    "华容区": 3602,
    "鄂城区": 41907,
    "京山县": 1478,
    "钟祥市": 2973,
    "沙洋县": 3055,
    "掇刀区": 3599,
    "东宝区": 3600,
    "广水市": 3163,
    "曾都区": 3164,
    "随县": 7357,
    "园林": 23585,
    "杨市": 23586,
    "周矶": 23587,
    "广华": 23588,
    "泰丰": 23589,
    "竹根滩镇": 23590,
    "高石碑镇": 23591,
    "积玉口镇": 23592,
    "渔洋镇": 23593,
    "王场镇": 23594,
    "熊口镇": 23595,
    "老新镇": 23596,
    "浩口镇": 23597,
    "张金镇": 23598,
    "龙湾镇": 23599,
    "江汉石油管理局": 23600,
    "潜江经济开发区": 23601,
    "西大垸管理区": 23602,
    "运粮湖管理区": 23603,
    "周矶管理区": 23604,
    "后湖管理区": 23605,
    "熊口管理区": 23606,
    "总口管理区": 23607,
    "高场原种场": 23608,
    "浩口原种场": 23609,
    "侨乡街道开发区": 23618,
    "竟陵街道": 23619,
    "杨林街道": 23620,
    "佛子山镇": 23621,
    "多宝镇": 23622,
    "拖市镇": 23623,
    "张港镇": 23624,
    "蒋场镇": 23625,
    "汪场镇": 23626,
    "渔薪镇": 23627,
    "黄潭镇": 23628,
    "岳口镇": 23629,
    "横林镇": 23630,
    "彭市镇": 23631,
    "麻洋镇": 23632,
    "多祥镇": 23633,
    "干驿镇": 23634,
    "马湾镇": 23635,
    "卢市镇": 23636,
    "小板镇": 23637,
    "九真镇": 23638,
    "皂市镇": 23639,
    "胡市镇": 23640,
    "石河镇": 23641,
    "净潭乡": 23642,
    "蒋湖农场": 23643,
    "白茅湖农场": 23644,
    "沉湖管委会": 23645,
    "郑场镇": 23649,
    "毛嘴镇": 23650,
    "豆河镇": 23651,
    "三伏潭镇": 23652,
    "胡场镇": 23653,
    "长埫口镇": 23654,
    "西流河镇": 23655,
    "沙湖镇": 23656,
    "杨林尾镇": 23657,
    "彭场镇": 23658,
    "张沟镇": 23659,
    "郭河镇": 23660,
    "沔城镇": 23661,
    "通海口镇": 23662,
    "陈场镇": 23663,
    "工业园区": 23664,
    "九合垸原种场": 23665,
    "沙湖原种场": 23666,
    "排湖渔场": 23667,
    "五湖渔场": 23668,
    "赵西垸林场": 23669,
    "刘家垸林场": 23670,
    "畜禽良种场": 23671,
    "城区": 52306,
    "松柏镇": 23610,
    "阳日镇": 23611,
    "木鱼镇": 23612,
    "红坪镇": 23613,
    "新华镇": 23614,
    "宋洛乡": 23615,
    "九湖乡": 23616,
    "下谷坪乡": 23617,
    "望城区": 1485,
    "芙蓉区": 3606,
    "岳麓区": 48936,
    "雨花区": 48937,
    "开福区": 48938,
    "天心区": 48939,
    "浏阳市": 48941,
    "长沙县": 48942,
    "宁乡县": 48943,
    "醴陵市": 1489,
    "株洲县": 1490,
    "攸县": 1491,
    "茶陵县": 1492,
    "炎陵县": 1493,
    "天元区": 29444,
    "石峰区": 29445,
    "芦淞区": 29446,
    "荷塘区": 29447,
    "云龙示范区": 53693,
    "湘乡市": 1496,
    "湘潭县": 1497,
    "韶山市": 1498,
    "雨湖区": 29448,
    "岳塘区": 29449,
    "常宁市": 1502,
    "衡阳县": 1503,
    "耒阳市": 1504,
    "衡东县": 1505,
    "衡南县": 1506,
    "衡山县": 1507,
    "祁东县": 1508,
    "南岳区": 1509,
    "蒸湘区": 29450,
    "石鼓区": 29451,
    "珠晖区": 29452,
    "雁峰区": 29453,
    "武冈市": 1512,
    "邵东县": 1513,
    "洞口县": 1514,
    "新邵县": 1515,
    "绥宁县": 1516,
    "新宁县": 1517,
    "邵阳县": 1518,
    "隆回县": 1519,
    "城步县": 1520,
    "大祥区": 29457,
    "双清区": 29458,
    "北塔区": 29459,
    "临湘市": 1523,
    "汨罗市": 1524,
    "岳阳县": 1525,
    "湘阴县": 1526,
    "华容县": 1527,
    "平江县": 1528,
    "君山区": 3619,
    "云溪区": 3620,
    "岳阳楼区": 29460,
    "津市市": 1532,
    "澧县": 1533,
    "临澧县": 1534,
    "桃源县": 1535,
    "汉寿县": 1536,
    "石门县": 1537,
    "安乡县": 1538,
    "鼎城区": 29461,
    "武陵区": 29462,
    "慈利县": 1541,
    "桑植县": 1542,
    "武陵源区": 1543,
    "永定区": 3622,
    "资兴市": 1545,
    "宜章县": 1546,
    "安仁县": 1547,
    "汝城县": 1548,
    "嘉禾县": 1549,
    "临武县": 1550,
    "桂东县": 1551,
    "永兴县": 1552,
    "桂阳县": 1553,
    "北湖区": 29465,
    "苏仙区": 29466,
    "南县": 1556,
    "桃江县": 1557,
    "安化县": 1558,
    "沅江市": 1565,
    "赫山区": 29463,
    "资阳区": 29464,
    "祁阳县": 1563,
    "双牌县": 1564,
    "道县": 1566,
    "江永县": 1567,
    "江华县": 1568,
    "宁远县": 1569,
    "新田县": 1570,
    "蓝山县": 1571,
    "东安县": 1572,
    "零陵区": 1573,
    "冷水滩区": 29454,
    "洪江市": 1575,
    "会同县": 1576,
    "溆浦县": 1578,
    "辰溪县": 1579,
    "靖州县": 1580,
    "通道县": 1581,
    "芷江县": 1582,
    "新晃县": 1583,
    "麻阳县": 1584,
    "沅陵县": 3070,
    "中方县": 3626,
    "鹤城区": 29455,
    "冷水江市": 1588,
    "涟源市": 1589,
    "新化县": 1590,
    "双峰县": 1591,
    "娄星区": 29456,
    "吉首市": 1593,
    "古丈县": 1594,
    "龙山县": 1595,
    "永顺县": 1596,
    "泸溪县": 1597,
    "凤凰县": 1598,
    "花垣县": 1599,
    "保靖县": 1600,
    "天河区": 3633,
    "海珠区": 3634,
    "荔湾区": 3635,
    "越秀区": 3637,
    "番禺区": 36953,
    "花都区": 50256,
    "白云区": 50258,
    "南沙区": 50259,
    "黄埔区": 50283,
    "增城区": 50284,
    "从化区": 50285,
    "广州大学城": 51091,
    "南山区": 3155,
    "罗湖区": 3638,
    "福田区": 3639,
    "宝安区": 4773,
    "光明新区": 6675,
    "坪山新区": 6736,
    "大鹏新区": 6737,
    "龙岗区": 40152,
    "盐田区": 47387,
    "龙华区": 47388,
    "斗门区": 41653,
    "金湾区": 41654,
    "香洲区": 41655,
    "南澳县": 1614,
    "龙湖区": 19916,
    "金平区": 19917,
    "澄海区": 19918,
    "潮阳区": 19919,
    "潮南区": 19920,
    "濠江区": 19921,
    "南雄市": 1618,
    "乐昌市": 1619,
    "仁化县": 1620,
    "始兴县": 1621,
    "翁源县": 1622,
    "新丰县": 1624,
    "乳源瑶族自治县": 1625,
    "曲江区": 1626,
    "武江区": 3643,
    "浈江区": 3644,
    "和平县": 1628,
    "龙川县": 1629,
    "紫金县": 1630,
    "连平县": 1631,
    "源城区": 37864,
    "东源县": 37865,
    "兴宁市": 1635,
    "梅县": 1636,
    "蕉岭县": 1637,
    "大埔县": 1638,
    "丰顺县": 1639,
    "五华县": 1640,
    "平远县": 1641,
    "梅江区": 1642,
    "龙门县": 1647,
    "惠阳区": 36174,
    "大亚湾区": 36175,
    "惠城区": 36176,
    "惠东县": 36177,
    "博罗县": 36178,
    "陆河县": 1653,
    "海丰县": 3037,
    "城区": 20051,
    "陆丰市": 20052,
    "中堂镇": 2950,
    "东坑镇": 3041,
    "道滘镇": 3078,
    "沙田镇": 3097,
    "高埗镇": 3100,
    "石龙镇": 3102,
    "石排镇": 3104,
    "企石镇": 3105,
    "石碣镇": 3111,
    "洪梅镇": 3116,
    "麻涌镇": 3120,
    "桥头镇": 3134,
    "望牛墩镇": 3151,
    "茶山镇": 3171,
    "谢岗镇": 4087,
    "松山湖": 4147,
    "莞城区": 4255,
    "南城区": 4256,
    "长安镇": 4760,
    "寮步镇": 4866,
    "大岭山镇": 4871,
    "常平镇": 4886,
    "厚街镇": 4910,
    "万江区": 4911,
    "樟木头镇": 4932,
    "大朗镇": 4980,
    "塘厦镇": 5457,
    "凤岗镇": 5473,
    "清溪镇": 5869,
    "横沥镇": 5905,
    "东城区": 36102,
    "黄江镇": 39461,
    "虎门镇": 39462,
    "南朗镇": 2777,
    "小榄镇": 2902,
    "古镇": 2957,
    "坦洲镇": 3001,
    "黄圃镇": 3007,
    "三乡镇": 3016,
    "东凤镇": 3067,
    "横栏镇": 3112,
    "三角镇": 3143,
    "南头镇": 3176,
    "沙溪镇": 3743,
    "五桂山镇": 4042,
    "阜沙镇": 4076,
    "东升镇": 4080,
    "板芙镇": 4102,
    "神湾镇": 4127,
    "港口镇": 4141,
    "大涌镇": 4190,
    "火炬开发区": 4852,
    "民众镇": 8540,
    "沙朗镇": 39653,
    "城区": 52093,
    "台山市": 37258,
    "新会区": 37259,
    "鹤山市": 37260,
    "江海区": 37261,
    "蓬江区": 37262,
    "开平市": 37263,
    "恩平市": 37264,
    "顺德区": 1669,
    "禅城区": 36264,
    "高明区": 36265,
    "三水区": 36266,
    "南海区": 36267,
    "阳春市": 1673,
    "阳西县": 1674,
    "江城区": 19827,
    "阳东县": 19828,
    "雷州市": 1679,
    "吴川市": 1680,
    "徐闻县": 1682,
    "坡头区": 3646,
    "赤坎区": 19377,
    "霞山区": 19378,
    "经济技术开发区": 19379,
    "麻章区": 19380,
    "遂溪县": 19381,
    "廉江市": 19382,
    "信宜市": 1687,
    "茂南区": 19465,
    "电白区": 19466,
    "高州市": 19467,
    "化州市": 19468,
    "广宁县": 1693,
    "德庆县": 1694,
    "怀集县": 1695,
    "封开县": 1696,
    "鼎湖区": 1697,
    "端州区": 4781,
    "四会市": 39723,
    "高要市": 39725,
    "云安县": 1700,
    "新兴县": 1701,
    "郁南县": 1702,
    "云城区": 19829,
    "罗定市": 19830,
    "连州市": 1795,
    "佛冈县": 1796,
    "阳山县": 1797,
    "清新县": 1798,
    "连山县": 1799,
    "连南县": 1800,
    "清城区": 37734,
    "英德市": 37735,
    "饶平县": 1707,
    "枫溪区": 4238,
    "湘桥区": 19991,
    "潮安区": 19992,
    "揭西县": 1712,
    "惠来县": 1713,
    "东山区": 5484,
    "普宁市": 5864,
    "榕城区": 20093,
    "揭东县": 20094,
    "武鸣区": 1716,
    "邕宁区": 1724,
    "宾阳县": 3005,
    "横县": 3650,
    "上林县": 3651,
    "隆安县": 3652,
    "马山县": 3653,
    "良庆区": 43114,
    "江南区": 43115,
    "兴宁区": 43116,
    "青秀区": 43117,
    "西乡塘区": 43118,
    "柳江县": 1721,
    "柳城县": 1722,
    "鹿寨县": 1725,
    "融安县": 3659,
    "三江县": 3660,
    "融水县": 3661,
    "鱼峰区": 22906,
    "城中区": 22907,
    "柳南区": 22908,
    "柳北区": 22909,
    "阳朔县": 1727,
    "临桂县": 1728,
    "灵川县": 1729,
    "全州县": 1730,
    "平乐县": 1731,
    "兴安县": 1732,
    "灌阳县": 1733,
    "荔浦县": 1734,
    "资源县": 1735,
    "永福县": 1736,
    "龙胜县": 1738,
    "恭城县": 3666,
    "象山区": 3670,
    "雁山区": 4457,
    "秀峰区": 22883,
    "叠彩区": 22884,
    "七星区": 22885,
    "岑溪市": 1741,
    "苍梧县": 1742,
    "藤县": 1743,
    "蒙山县": 1744,
    "万秀区": 23037,
    "蝶山区": 23038,
    "长洲区": 23039,
    "龙圩区": 53521,
    "合浦县": 1747,
    "铁山港区": 1748,
    "海城区": 22851,
    "银海区": 22852,
    "东兴市": 1750,
    "上思县": 1751,
    "防城区": 25190,
    "港口区": 25191,
    "浦北县": 1754,
    "灵山县": 1755,
    "钦北区": 2999,
    "钦南区": 25189,
    "桂平市": 1758,
    "平南县": 1759,
    "覃塘区": 1760,
    "港南区": 25192,
    "港北区": 25193,
    "北流市": 1762,
    "容县": 1763,
    "博白县": 1764,
    "陆川县": 1765,
    "兴业县": 1766,
    "玉州区": 25188,
    "钟山县": 1803,
    "昭平县": 1804,
    "富川县": 1805,
    "平桂管理区": 22850,
    "八步区": 23040,
    "右江区": 1807,
    "平果县": 1808,
    "乐业县": 1809,
    "田阳县": 1810,
    "西林县": 1811,
    "田林县": 1812,
    "德保县": 1813,
    "靖西县": 1814,
    "田东县": 1815,
    "那坡县": 1816,
    "隆林县": 1817,
    "凌云县": 3678,
    "宜州市": 1820,
    "天峨县": 1821,
    "凤山县": 1822,
    "南丹县": 1823,
    "东兰县": 1824,
    "巴马县": 1825,
    "环江县": 1826,
    "罗城县": 2991,
    "大化县": 3152,
    "都安县": 3679,
    "金城江区": 3680,
    "兴宾区": 3046,
    "合山市": 3047,
    "忻城县": 3048,
    "武宣县": 3049,
    "象州县": 3050,
    "金秀县": 3051,
    "江州区": 3169,
    "凭祥市": 3681,
    "扶绥县": 3682,
    "大新县": 3683,
    "天等县": 3684,
    "宁明县": 3685,
    "龙州县": 3686,
    "南昌县": 1828,
    "进贤县": 1829,
    "安义县": 1830,
    "新建县": 3502,
    "湾里区": 3504,
    "青云谱区": 3505,
    "西湖区": 3506,
    "东湖区": 3507,
    "高新区": 4039,
    "昌北区": 4101,
    "青山湖区": 40846,
    "红谷滩新区": 40847,
    "乐平市": 1833,
    "浮梁县": 1834,
    "珠山区": 3508,
    "昌江区": 24947,
    "湘东区": 1837,
    "莲花县": 1838,
    "上栗县": 1839,
    "芦溪县": 1840,
    "安源区": 18317,
    "分宜县": 1843,
    "渝水区": 26455,
    "柴桑区": 1846,
    "瑞昌市": 1847,
    "庐山市": 1848,
    "武宁县": 1849,
    "彭泽县": 1850,
    "永修县": 1851,
    "修水县": 1852,
    "湖口县": 1853,
    "德安县": 1854,
    "都昌县": 1855,
    "共青城市": 4161,
    "经济技术开发区": 23678,
    "八里湖新区": 23679,
    "庐山风景名胜区": 23680,
    "濂溪区": 25481,
    "浔阳区": 25482,
    "余江县": 1858,
    "贵溪市": 1859,
    "月湖区": 1860,
    "龙虎山风景旅游区": 51245,
    "德兴市": 1863,
    "广丰县": 1864,
    "鄱阳县": 1865,
    "婺源县": 1866,
    "余干县": 1867,
    "横峰县": 1868,
    "弋阳县": 1869,
    "铅山县": 1870,
    "玉山县": 1871,
    "万年县": 1872,
    "信州区": 26449,
    "上饶县": 26450,
    "丰城市": 1875,
    "樟树市": 1876,
    "高安市": 1877,
    "铜鼓县": 1878,
    "靖安县": 1879,
    "宜丰县": 1880,
    "奉新县": 1881,
    "万载县": 1882,
    "上高县": 1883,
    "袁州区": 26452,
    "南丰县": 1887,
    "乐安县": 1888,
    "金溪县": 1889,
    "南城县": 1890,
    "东乡县": 1891,
    "资溪县": 1892,
    "宜黄县": 1893,
    "崇仁县": 1894,
    "黎川县": 1895,
    "广昌县": 1896,
    "临川区": 24946,
    "井冈山市": 1899,
    "吉安县": 1900,
    "永丰县": 1901,
    "永新县": 1902,
    "新干县": 1903,
    "泰和县": 1904,
    "峡江县": 1905,
    "遂川县": 1906,
    "安福县": 1907,
    "吉水县": 1908,
    "万安县": 1909,
    "青原区": 26453,
    "吉州区": 26454,
    "南康市": 1912,
    "瑞金市": 1913,
    "石城县": 1914,
    "安远县": 1915,
    "赣县": 1916,
    "宁都县": 1917,
    "寻乌县": 1918,
    "兴国县": 1919,
    "定南县": 1920,
    "上犹县": 1921,
    "于都县": 1922,
    "龙南县": 1923,
    "崇义县": 1924,
    "大余县": 1925,
    "信丰县": 1926,
    "全南县": 1927,
    "会昌县": 1928,
    "章贡区": 26451,
    "高新西区": 4284,
    "新都区": 49314,
    "温江区": 49315,
    "龙泉驿区": 49316,
    "青白江区": 49317,
    "彭州市": 49318,
    "崇州市": 49319,
    "邛崃市": 49320,
    "都江堰市": 49321,
    "郫都区": 49322,
    "新津县": 49323,
    "双流区": 49324,
    "大邑县": 49325,
    "蒲江县": 49326,
    "金堂县": 49327,
    "青羊区": 50944,
    "锦江区": 50945,
    "金牛区": 50946,
    "武侯区": 50947,
    "成华区": 50948,
    "高新区": 50949,
    "荣县": 1947,
    "富顺县": 1948,
    "自流井区": 1949,
    "沿滩区": 3895,
    "大安区": 43224,
    "贡井区": 43225,
    "米易县": 1951,
    "盐边县": 1952,
    "仁和区": 1953,
    "西区": 3896,
    "东区": 27502,
    "泸县": 1955,
    "合江县": 1956,
    "叙永县": 1957,
    "古蔺县": 1958,
    "纳溪区": 3898,
    "江阳区": 39014,
    "龙马潭区": 39015,
    "盐亭县": 1970,
    "三台县": 1971,
    "平武县": 1972,
    "北川县": 1973,
    "安州区": 1974,
    "梓潼县": 1975,
    "江油市": 38573,
    "涪城区": 38574,
    "游仙区": 38575,
    "高新区": 38576,
    "经开区": 38577,
    "罗江县": 1965,
    "中江县": 1966,
    "广汉市": 39010,
    "什邡市": 39011,
    "旌阳区": 39012,
    "绵竹市": 39013,
    "青川县": 1978,
    "旺苍县": 1979,
    "剑阁县": 1980,
    "苍溪县": 1981,
    "昭化区": 3901,
    "朝天区": 3902,
    "利州区": 27499,
    "射洪县": 1984,
    "蓬溪县": 1985,
    "大英县": 1986,
    "安居区": 1987,
    "船山区": 4961,
    "资中县": 1989,
    "隆昌县": 1990,
    "威远县": 1991,
    "市中区": 1992,
    "东兴区": 3121,
    "五通桥区": 1994,
    "沙湾区": 1995,
    "金口河区": 1996,
    "夹江县": 1998,
    "井研县": 1999,
    "犍为县": 2000,
    "沐川县": 2001,
    "峨边县": 2002,
    "马边县": 2003,
    "市中区": 36983,
    "峨眉山市": 36984,
    "宜宾县": 2006,
    "南溪区": 2007,
    "江安县": 2008,
    "长宁县": 2009,
    "兴文县": 2010,
    "珙县": 2011,
    "高县": 2012,
    "屏山县": 2013,
    "筠连县": 2015,
    "翠屏区": 36315,
    "岳池县": 2017,
    "武胜县": 2018,
    "邻水县": 2019,
    "广安区": 2020,
    "华蓥市": 2021,
    "前锋区": 52607,
    "仪陇县": 2028,
    "蓬安县": 2029,
    "营山县": 2030,
    "南部县": 36936,
    "顺庆区": 43226,
    "高坪区": 43227,
    "嘉陵区": 43228,
    "西充县": 43229,
    "阆中市": 43230,
    "通川区": 2034,
    "达川区": 2035,
    "大竹县": 2036,
    "渠县": 2037,
    "万源市": 2038,
    "宣汉县": 2039,
    "开江县": 2040,
    "南江县": 2044,
    "平昌县": 2045,
    "通江县": 2046,
    "巴州区": 3904,
    "恩阳区": 52623,
    "芦山县": 2049,
    "石棉县": 2052,
    "名山区": 2053,
    "天全县": 2054,
    "荥经县": 2055,
    "汉源县": 2056,
    "宝兴县": 2057,
    "雨城区": 41028,
    "仁寿县": 2060,
    "彭山区": 2061,
    "洪雅县": 2062,
    "丹棱县": 2063,
    "青神县": 2064,
    "东坡区": 41029,
    "安岳县": 2068,
    "乐至县": 2069,
    "雁江区": 3905,
    "简阳市": 44342,
    "马尔康市": 2071,
    "九寨沟县": 2072,
    "红原县": 2073,
    "阿坝县": 2075,
    "理县": 2076,
    "若尔盖县": 2077,
    "金川县": 2078,
    "小金县": 2079,
    "黑水县": 2080,
    "松潘县": 2081,
    "壤塘县": 2082,
    "茂县": 2083,
    "汶川县": 27498,
    "康定市": 2085,
    "泸定县": 2086,
    "九龙县": 2087,
    "丹巴县": 2088,
    "道孚县": 2089,
    "炉霍县": 2090,
    "色达县": 2091,
    "甘孜县": 2092,
    "新龙县": 2093,
    "白玉县": 2094,
    "德格县": 2095,
    "石渠县": 2096,
    "雅江县": 2097,
    "理塘县": 2098,
    "巴塘县": 2099,
    "稻城县": 2100,
    "乡城县": 2101,
    "得荣县": 2102,
    "美姑县": 2105,
    "昭觉县": 2106,
    "会理县": 2107,
    "会东县": 2108,
    "普格县": 2109,
    "宁南县": 2110,
    "德昌县": 2111,
    "冕宁县": 2112,
    "盐源县": 2113,
    "金阳县": 2114,
    "布拖县": 2115,
    "雷波县": 2116,
    "越西县": 2117,
    "喜德县": 2118,
    "甘洛县": 2119,
    "木里县": 2120,
    "西昌市": 27500,
    "秀英区": 22466,
    "龙华区": 22467,
    "琼山区": 22468,
    "美兰区": 22469,
    "那大镇": 3125,
    "和庆镇": 3733,
    "南丰镇": 3734,
    "大成镇": 3735,
    "雅星镇": 3736,
    "兰洋镇": 3737,
    "光村镇": 3738,
    "木棠镇": 3739,
    "海头镇": 3740,
    "峨蔓镇": 3741,
    "三都镇": 3744,
    "王五镇": 3745,
    "白马井镇": 3746,
    "中和镇": 3747,
    "排浦镇": 3748,
    "东成镇": 3749,
    "新州镇": 3750,
    "洋浦经济开发区": 3751,
    "富克镇": 4214,
    "西培农场": 12752,
    "西联农场": 12753,
    "蓝洋农场": 12754,
    "八一农场": 12755,
    "西华农场": 12756,
    "西庆农场": 12757,
    "西流农场": 12758,
    "新盈农场": 12759,
    "龙山农场": 12760,
    "红岭农场": 12761,
    "热作学院": 12824,
    "嘉积镇": 3720,
    "万泉镇": 3721,
    "石壁镇": 3722,
    "中原镇": 3723,
    "博鳌镇": 3724,
    "阳江镇": 3725,
    "龙江镇": 3727,
    "潭门镇": 3728,
    "塔洋镇": 3729,
    "长坡镇": 3730,
    "大路镇": 3731,
    "会山镇": 3732,
    "彬村山华侨农场": 12747,
    "东太农场": 12748,
    "东红农场": 12749,
    "东升农场": 12750,
    "南俸农场": 12751,
    "万城镇": 3768,
    "龙滚镇": 3769,
    "和乐镇": 3770,
    "后安镇": 3771,
    "大茂镇": 3772,
    "东澳镇": 3773,
    "礼纪镇": 3774,
    "长丰镇": 3775,
    "山根镇": 3776,
    "北大镇": 3777,
    "南桥镇": 3778,
    "三更罗镇": 3779,
    "六连林场": 12775,
    "东兴农场": 12776,
    "东和农场": 12777,
    "新中农场": 12778,
    "兴隆华侨农场": 12779,
    "兴隆镇": 53111,
    "南林农场": 53112,
    "八所镇": 3780,
    "东河镇": 3781,
    "大田镇": 3782,
    "感城镇": 3783,
    "板桥镇": 3784,
    "三家镇": 3785,
    "四更镇": 3786,
    "新龙镇": 3787,
    "天安乡": 3788,
    "江边乡": 3789,
    "广坝农场": 12780,
    "东方华侨农场": 12781,
    "海棠区": 3693,
    "吉阳区": 3694,
    "天涯区": 3696,
    "崖州区": 4182,
    "文城镇": 3752,
    "重兴镇": 3753,
    "蓬莱镇": 3754,
    "会文镇": 3755,
    "东路镇": 3756,
    "潭牛镇": 3757,
    "东阁镇": 3758,
    "文教镇": 3759,
    "东郊镇": 3760,
    "龙楼镇": 3761,
    "昌洒镇": 3762,
    "翁田镇": 3763,
    "抱罗镇": 3764,
    "冯坡镇": 3765,
    "锦山镇": 3766,
    "铺前镇": 3767,
    "公坡镇": 12762,
    "迈号镇": 12763,
    "清谰镇": 12764,
    "南阳镇": 12765,
    "新桥镇": 12766,
    "头苑镇": 12767,
    "宝芳乡": 12768,
    "龙马乡": 12769,
    "湖山乡": 12770,
    "东路农场": 12771,
    "南阳农场": 12772,
    "罗豆农场": 12773,
    "橡胶研究所": 12774,
    "通什镇": 3712,
    "南圣镇": 3713,
    "毛阳镇": 3714,
    "番阳镇": 3715,
    "畅好乡": 3716,
    "毛道乡": 3717,
    "水满乡": 3719,
    "畅好农场": 12746,
    "临城镇": 3790,
    "波莲镇": 3791,
    "东英镇": 3792,
    "博厚镇": 3793,
    "皇桐镇": 3794,
    "多文镇": 3795,
    "和舍镇": 3796,
    "南宝镇": 3797,
    "新盈镇": 3798,
    "调楼镇": 3799,
    "加来镇": 3800,
    "红华农场": 12791,
    "加来农场": 12792,
    "城区": 39884,
    "金江镇": 3801,
    "老城镇": 3802,
    "瑞溪镇": 3803,
    "永发镇": 3804,
    "加乐镇": 3805,
    "文儒镇": 3806,
    "中兴镇": 3807,
    "仁兴镇": 3808,
    "福山镇": 3809,
    "桥头镇": 3810,
    "大丰镇": 12787,
    "红光农场": 12788,
    "西达农场": 12789,
    "金安农场": 12790,
    "城区": 39886,
    "定城镇": 3811,
    "新竹镇": 3812,
    "龙湖镇": 3813,
    "雷鸣镇": 3814,
    "龙门镇": 3815,
    "龙河镇": 3816,
    "岭口镇": 3817,
    "翰林镇": 3818,
    "富文镇": 3819,
    "黄竹镇": 4498,
    "金鸡岭农场": 12782,
    "中瑞农场": 12783,
    "南海农场": 12784,
    "城区": 39887,
    "屯城镇": 3820,
    "新兴镇": 3821,
    "枫木镇": 3822,
    "乌坡镇": 3823,
    "南吕镇": 3824,
    "南坤镇": 3825,
    "坡心镇": 3826,
    "西昌镇": 3827,
    "中建农场": 12785,
    "中坤农场": 12786,
    "县城内": 39889,
    "石碌镇": 3828,
    "叉河镇": 3829,
    "十月田镇": 3830,
    "乌烈镇": 3831,
    "昌化镇": 3832,
    "海尾镇": 3833,
    "七叉镇": 12796,
    "王下乡": 12797,
    "海南矿业公司": 12798,
    "霸王岭林场": 12799,
    "红林农场": 12800,
    "城区": 39890,
    "牙叉镇": 3834,
    "七坊镇": 3835,
    "邦溪镇": 3836,
    "打安镇": 3837,
    "细水乡": 3838,
    "元门乡": 3839,
    "南开乡": 3840,
    "阜龙乡": 3841,
    "青松乡": 3842,
    "金波乡": 3843,
    "荣邦乡": 3844,
    "白沙农场": 12793,
    "龙江农场": 12794,
    "邦溪农场": 12795,
    "城区": 39892,
    "营根镇": 3878,
    "湾岭镇": 3879,
    "黎母山镇": 3880,
    "和平镇": 3881,
    "长征镇": 3882,
    "红毛镇": 3883,
    "中平镇": 3884,
    "上安乡": 3885,
    "什运乡": 3886,
    "吊罗山乡": 12813,
    "黎母山林业公司": 12814,
    "阳江农场": 12815,
    "乌石农场": 12816,
    "加钗农场": 12817,
    "长征农场": 12818,
    "城区": 39893,
    "椰林镇": 3858,
    "光坡镇": 3859,
    "三才镇": 3860,
    "英州镇": 3861,
    "隆广镇": 3862,
    "文罗镇": 3863,
    "本号镇": 3864,
    "新村镇": 3865,
    "黎安镇": 3866,
    "提蒙乡": 3867,
    "群英乡": 3868,
    "吊罗山林业公司": 12806,
    "岭门农场": 12807,
    "南平农场": 12808,
    "城区": 39895,
    "东华镇": 53109,
    "南平镇": 53110,
    "保城镇": 3869,
    "什玲镇": 3870,
    "加茂镇": 3871,
    "响水镇": 3872,
    "新政镇": 3873,
    "三道镇": 3874,
    "六弓乡": 3875,
    "南林乡": 3876,
    "毛感乡": 3877,
    "保亭研究所": 12809,
    "新星农场": 12810,
    "金江农场": 12811,
    "三道农场": 12812,
    "抱由镇": 3845,
    "万冲镇": 3846,
    "大安镇": 3847,
    "志仲镇": 3849,
    "千家镇": 3851,
    "九所镇": 3852,
    "利国镇": 3853,
    "黄流镇": 3854,
    "佛罗镇": 3855,
    "尖峰镇": 3856,
    "莺歌海镇": 3857,
    "尖峰岭林业公司": 12801,
    "莺歌海盐场": 12802,
    "山荣农场": 12803,
    "乐光农场": 12804,
    "保国农场": 12805,
    "城区": 39897,
    "西沙群岛": 3887,
    "南沙群岛": 3888,
    "中沙群岛": 12819,
    "清镇市": 2145,
    "开阳县": 2146,
    "修文县": 2147,
    "息烽县": 2148,
    "乌当区": 2149,
    "南明区": 3906,
    "白云区": 3909,
    "云岩区": 21037,
    "花溪区": 21038,
    "小河区": 21039,
    "观山湖区": 24463,
    "盘县": 2151,
    "六枝特区": 2152,
    "水城县": 2153,
    "钟山区": 2154,
    "赤水市": 2156,
    "仁怀市": 2157,
    "播州区": 2158,
    "桐梓县": 2159,
    "绥阳县": 2160,
    "习水县": 2161,
    "凤冈县": 2162,
    "正安县": 2163,
    "湄潭县": 2164,
    "余庆县": 2165,
    "道真县": 2166,
    "务川县": 2167,
    "红花岗区": 21035,
    "汇川区": 21036,
    "碧江区": 2170,
    "德江县": 2171,
    "江口县": 2172,
    "思南县": 2173,
    "万山区": 2174,
    "石阡县": 2175,
    "玉屏侗族自治县": 2176,
    "松桃苗族自治县": 2177,
    "印江土家族苗族自治县": 2178,
    "沿河土家族自治县": 2179,
    "黔西县": 2182,
    "大方县": 2183,
    "织金县": 2184,
    "金沙县": 2185,
    "赫章县": 2186,
    "纳雍县": 2187,
    "威宁彝族回族苗族自治县": 2188,
    "七星关区": 8891,
    "西秀区": 2190,
    "普定县": 2191,
    "平坝区": 2192,
    "镇宁布依族苗族自治县": 2193,
    "关岭布依族苗族自治县": 2194,
    "紫云苗族布依族自治县": 2195,
    "兴义市": 2197,
    "望谟县": 2198,
    "兴仁县": 2199,
    "普安县": 2200,
    "册亨县": 2201,
    "晴隆县": 2202,
    "贞丰县": 2203,
    "安龙县": 2204,
    "凯里市": 2206,
    "施秉县": 2207,
    "从江县": 2208,
    "锦屏县": 2209,
    "镇远县": 2210,
    "麻江县": 2211,
    "台江县": 2212,
    "天柱县": 2213,
    "黄平县": 2214,
    "榕江县": 2215,
    "剑河县": 2216,
    "三穗县": 2217,
    "雷山县": 2218,
    "黎平县": 2219,
    "岑巩县": 2220,
    "丹寨县": 2221,
    "都匀市": 2223,
    "福泉市": 2224,
    "贵定县": 2225,
    "惠水县": 2226,
    "罗甸县": 2227,
    "瓮安县": 2228,
    "荔波县": 2229,
    "龙里县": 2230,
    "平塘县": 2231,
    "长顺县": 2232,
    "独山县": 2233,
    "三都县": 2234,
    "东川区": 2236,
    "安宁市": 2237,
    "富民县": 2238,
    "嵩明县": 2239,
    "晋宁区": 2241,
    "宜良县": 2242,
    "禄劝县": 2243,
    "石林县": 2244,
    "寻甸县": 2245,
    "盘龙区": 2246,
    "五华区": 3912,
    "官渡区": 3913,
    "西山区": 3914,
    "呈贡区": 27497,
    "马龙县": 2249,
    "宣威市": 2250,
    "富源县": 2251,
    "会泽县": 2252,
    "陆良县": 2253,
    "师宗县": 2254,
    "罗平县": 2255,
    "沾益区": 2256,
    "麒麟区": 21034,
    "红塔区": 2259,
    "华宁县": 2260,
    "澄江县": 2261,
    "易门县": 2262,
    "通海县": 2263,
    "江川区": 2264,
    "元江县": 2265,
    "新平县": 2266,
    "峨山县": 2267,
    "昭阳区": 2271,
    "镇雄县": 2272,
    "永善县": 2273,
    "大关县": 2274,
    "盐津县": 2275,
    "彝良县": 2276,
    "水富县": 2277,
    "巧家县": 2278,
    "威信县": 2279,
    "鲁甸县": 3002,
    "绥江县": 3003,
    "思茅区": 2282,
    "宁洱县": 2283,
    "景东县": 2284,
    "镇沅县": 2285,
    "景谷县": 2286,
    "墨江县": 2287,
    "澜沧县": 2288,
    "西盟县": 2289,
    "江城县": 2290,
    "孟连县": 2958,
    "临翔区": 2292,
    "镇康县": 2293,
    "凤庆县": 2294,
    "云县": 2295,
    "永德县": 2296,
    "耿马县": 2297,
    "双江县": 3915,
    "沧源县": 3916,
    "隆阳区": 2299,
    "施甸县": 2300,
    "昌宁县": 2301,
    "龙陵县": 2302,
    "腾冲市": 2303,
    "玉龙县": 2305,
    "华坪县": 2306,
    "永胜县": 2307,
    "宁蒗县": 2308,
    "古城区": 21033,
    "文山市": 2310,
    "麻栗坡县": 2311,
    "砚山县": 2312,
    "广南县": 2313,
    "马关县": 2314,
    "富宁县": 2315,
    "西畴县": 2316,
    "丘北县": 2317,
    "个旧市": 2319,
    "开远市": 2320,
    "弥勒市": 2321,
    "红河县": 2322,
    "绿春县": 2323,
    "蒙自市": 2324,
    "泸西县": 2325,
    "建水县": 2326,
    "元阳县": 2327,
    "石屏县": 2328,
    "金平县": 2329,
    "屏边县": 2330,
    "河口县": 2331,
    "景洪市": 2333,
    "勐海县": 2334,
    "勐腊县": 2335,
    "元谋县": 2338,
    "南华县": 2339,
    "牟定县": 2340,
    "武定县": 2341,
    "大姚县": 2342,
    "双柏县": 2343,
    "禄丰县": 2344,
    "永仁县": 2345,
    "姚安县": 3917,
    "楚雄市": 20817,
    "剑川县": 2349,
    "弥渡县": 2350,
    "云龙县": 2351,
    "洱源县": 2352,
    "鹤庆县": 2353,
    "宾川县": 2354,
    "祥云县": 2355,
    "永平县": 2356,
    "巍山县": 2357,
    "漾濞县": 2358,
    "南涧县": 2359,
    "大理市": 20818,
    "芒市": 2361,
    "瑞丽市": 2362,
    "盈江县": 2363,
    "梁河县": 2364,
    "陇川县": 2365,
    "泸水市": 2367,
    "福贡县": 2368,
    "兰坪县": 2369,
    "贡山县": 2370,
    "香格里拉市": 6823,
    "德钦县": 6824,
    "维西县": 6825,
    "城关区": 2952,
    "林周县": 3123,
    "当雄县": 3918,
    "尼木县": 3919,
    "曲水县": 3920,
    "堆龙德庆区": 3921,
    "达孜县": 3922,
    "墨竹工卡县": 3923,
    "索县": 3108,
    "那曲县": 3961,
    "嘉黎县": 3962,
    "比如县": 3963,
    "聂荣县": 3964,
    "安多县": 3965,
    "申扎县": 3966,
    "班戈县": 3967,
    "巴青县": 3968,
    "尼玛县": 3969,
    "双湖县": 53091,
    "贡嘎县": 3130,
    "扎囊县": 3934,
    "乃东区": 3935,
    "桑日县": 3936,
    "琼结县": 3937,
    "曲松县": 3938,
    "措美县": 3939,
    "洛扎县": 3940,
    "加查县": 3941,
    "隆子县": 3942,
    "错那县": 3943,
    "浪卡子县": 3944,
    "卡若区": 3139,
    "江达县": 3924,
    "贡觉县": 3925,
    "类乌齐县": 3926,
    "丁青县": 3927,
    "察雅县": 3928,
    "八宿县": 3929,
    "左贡县": 3930,
    "芒康县": 3931,
    "洛隆县": 3932,
    "边坝县": 3933,
    "聂拉木县": 3160,
    "昂仁县": 3166,
    "桑珠孜区": 3945,
    "南木林县": 3946,
    "江孜县": 3947,
    "定日县": 3948,
    "萨迦县　": 3949,
    "拉孜县": 3950,
    "谢通门县": 3951,
    "白朗县": 3952,
    "仁布县": 3953,
    "康马县": 3954,
    "定结县": 3955,
    "仲巴县": 3956,
    "亚东县": 3957,
    "吉隆县": 3958,
    "萨嘎县": 3959,
    "岗巴县": 3960,
    "噶尔县": 3972,
    "普兰县": 3973,
    "札达县　": 3974,
    "日土县": 3975,
    "革吉县": 3976,
    "改则县": 3977,
    "措勤县": 3978,
    "巴宜区": 3979,
    "工布江达县": 3980,
    "米林县": 3981,
    "墨脱县": 3982,
    "波密县": 3983,
    "察隅县": 3984,
    "朗县": 3985,
    "高陵县": 2380,
    "蓝田县": 2381,
    "户县": 2382,
    "周至县": 2383,
    "雁塔区": 4343,
    "未央区": 50230,
    "长安区": 50231,
    "灞桥区": 50232,
    "碑林区": 50233,
    "莲湖区": 50235,
    "临潼区": 50236,
    "阎良区": 50237,
    "新城区": 51881,
    "西安武警工程学院": 52075,
    "印台区": 2387,
    "宜君县": 2388,
    "王益区": 2389,
    "耀州区": 3989,
    "岐山县": 2392,
    "太白县": 2393,
    "凤翔县": 2394,
    "陇县": 2395,
    "麟游县": 2396,
    "千阳县": 2397,
    "扶风县": 2398,
    "凤县": 2399,
    "眉县": 2400,
    "渭滨区": 2401,
    "金台区": 3990,
    "陈仓区": 40650,
    "兴平市": 2403,
    "礼泉县": 2404,
    "泾阳县": 2405,
    "永寿县": 2406,
    "三原县": 2407,
    "彬县": 2408,
    "旬邑县": 2409,
    "长武县": 2411,
    "乾县": 2412,
    "武功县": 2413,
    "淳化县": 2414,
    "秦都区": 44320,
    "渭城区": 44321,
    "杨陵区": 44514,
    "韩城市": 2417,
    "华阴市": 2418,
    "蒲城县": 2419,
    "华县": 2420,
    "潼关县": 2421,
    "大荔县": 2422,
    "澄城县": 2423,
    "合阳县": 2424,
    "白水县": 2425,
    "富平县": 2426,
    "临渭区": 38094,
    "安塞县": 2429,
    "洛川县": 2430,
    "子长县": 2431,
    "黄陵县": 2432,
    "延长县": 2433,
    "宜川县": 2434,
    "延川县": 2435,
    "甘泉县": 2436,
    "富县": 2437,
    "志丹县": 2438,
    "黄龙县": 2439,
    "吴起县": 2440,
    "宝塔区": 31523,
    "南郑县": 2443,
    "城固县": 2444,
    "洋县": 2445,
    "佛坪县": 2446,
    "留坝县": 2447,
    "镇巴县": 2448,
    "西乡县": 2449,
    "勉县": 2450,
    "略阳县": 2451,
    "宁强县": 2452,
    "汉台区": 31864,
    "经济开发区南区": 53107,
    "清涧县": 2456,
    "绥德县": 2457,
    "佳县": 2459,
    "神木市": 2460,
    "府谷县": 2461,
    "子洲县": 2462,
    "横山县": 2464,
    "米脂县": 2465,
    "吴堡县": 2466,
    "定边县": 2467,
    "靖边县": 4081,
    "榆阳区": 31680,
    "商州区": 2469,
    "镇安县": 2470,
    "山阳县": 2471,
    "洛南县": 2472,
    "商南县": 2473,
    "丹凤县": 2474,
    "柞水县": 2475,
    "紫阳县": 2478,
    "岚皋县": 2479,
    "旬阳县": 2480,
    "镇坪县": 2481,
    "平利县": 2482,
    "宁陕县": 2483,
    "汉阴县": 2484,
    "石泉县": 2485,
    "白河县": 2486,
    "汉滨区": 3993,
    "永登县": 2488,
    "榆中县": 2489,
    "皋兰县": 2490,
    "西固区": 3995,
    "红古区": 3997,
    "七里河区": 21646,
    "安宁区": 21647,
    "城关区": 21648,
    "永昌县": 2493,
    "金川区": 2494,
    "白银区": 2496,
    "平川区": 2497,
    "靖远县": 2498,
    "景泰县": 2499,
    "会宁县": 2500,
    "甘谷县": 2504,
    "武山县": 2505,
    "清水县": 2506,
    "秦安县": 2507,
    "张家川县": 2508,
    "麦积区": 21644,
    "秦州区": 21645,
    "雄关区": 2970,
    "长城区": 16899,
    "镜铁区": 16923,
    "华亭县": 2519,
    "崇信县": 2520,
    "泾川县": 2521,
    "灵台县": 2522,
    "庄浪县": 2524,
    "崆峒区": 3023,
    "静宁县": 3998,
    "西峰区": 2526,
    "镇原县": 2528,
    "合水县": 2529,
    "华池县": 2530,
    "环县": 2531,
    "宁县": 2532,
    "正宁县": 2533,
    "庆城县": 4001,
    "成县": 2535,
    "礼县": 2536,
    "康县": 2537,
    "武都区": 2538,
    "文县": 2539,
    "两当县": 2540,
    "徽县": 2541,
    "宕昌县": 2542,
    "西和县": 2543,
    "凉州区": 2545,
    "古浪县": 2546,
    "天祝县": 2547,
    "民勤县": 2548,
    "甘州区": 2550,
    "山丹县": 2551,
    "临泽县": 2552,
    "高台县": 2553,
    "肃南县": 2554,
    "民乐县": 2555,
    "玉门市": 2558,
    "敦煌市": 2559,
    "金塔县": 2560,
    "阿克塞县": 2562,
    "肃北县": 2563,
    "瓜州县": 3999,
    "肃州区": 4000,
    "合作市": 2565,
    "夏河县": 2566,
    "碌曲县": 2567,
    "舟曲县": 2568,
    "玛曲县": 2569,
    "迭部县": 2570,
    "临潭县": 2571,
    "卓尼县": 2572,
    "临夏县": 2574,
    "康乐县": 2575,
    "永靖县": 2576,
    "和政县": 2577,
    "东乡族自治县": 2578,
    "积石山县": 2579,
    "临夏市": 3175,
    "广河县": 4008,
    "岷县": 3081,
    "安定区": 4002,
    "通渭县": 4003,
    "临洮县": 4004,
    "漳县": 4005,
    "渭源县": 4006,
    "陇西县": 4007,
    "湟中县": 2581,
    "湟源县": 2582,
    "大通县": 2583,
    "城中区": 21652,
    "城东区": 21653,
    "城西区": 21654,
    "城北区": 21655,
    "平安县": 2586,
    "乐都县": 2587,
    "民和县": 2588,
    "互助县": 2589,
    "化隆县": 2590,
    "循化县": 2591,
    "海晏县": 2593,
    "祁连县": 2594,
    "刚察县": 2595,
    "门源县": 2596,
    "尖扎县": 2598,
    "同仁县": 2599,
    "泽库县": 2600,
    "河南县": 2602,
    "共和县": 4012,
    "同德县": 4013,
    "贵德县": 4014,
    "兴海县": 4015,
    "贵南县": 4016,
    "玛沁县": 2606,
    "甘德县": 2607,
    "达日县": 2608,
    "班玛县": 2609,
    "久治县": 2610,
    "玛多县": 2611,
    "玉树县": 2613,
    "称多县": 2614,
    "囊谦县": 2615,
    "杂多县": 2616,
    "治多县": 2617,
    "曲麻莱县": 2618,
    "德令哈市": 2621,
    "乌兰县": 2622,
    "天峻县": 2623,
    "都兰县": 2624,
    "大柴旦行委": 2625,
    "冷湖行委": 2626,
    "茫崖行委": 2627,
    "格尔木市": 3021,
    "灵武市": 2629,
    "永宁县": 2630,
    "贺兰县": 2631,
    "兴庆区": 21649,
    "金凤区": 21650,
    "西夏区": 21651,
    "平罗县": 2633,
    "惠农区": 2635,
    "大武口区": 2636,
    "青铜峡市": 2638,
    "同心县": 2641,
    "盐池县": 2642,
    "红寺堡开发区": 2643,
    "利通区": 2966,
    "西吉县": 2647,
    "隆德县": 2648,
    "泾源县": 2649,
    "彭阳县": 2650,
    "原州区": 2651,
    "中宁县": 3072,
    "海原县": 3148,
    "沙坡头区": 4020,
    "乌鲁木齐县": 2653,
    "头屯河区": 4024,
    "达坂城区": 4025,
    "米东区": 4026,
    "天山区": 36684,
    "新市区": 36685,
    "沙依巴克区": 36686,
    "水磨沟区": 36687,
    "克拉玛依区": 2655,
    "独山子区": 2930,
    "白碱滩区": 3006,
    "乌尔禾区": 4027,
    "石河子市": 2657,
    "吐鲁番市": 2659,
    "托克逊县": 2660,
    "鄯善县": 2661,
    "哈密市": 2663,
    "巴里坤县": 2664,
    "伊吾县": 2665,
    "和田市": 2667,
    "墨玉县": 2669,
    "洛浦县": 2670,
    "策勒县": 2671,
    "于田县": 2672,
    "民丰县": 2673,
    "皮山县": 2674,
    "和田县": 14848,
    "阿克苏市": 2676,
    "温宿县": 2678,
    "沙雅县": 2679,
    "拜城县": 2680,
    "阿瓦提县": 2681,
    "库车县": 2682,
    "柯坪县": 2683,
    "新和县": 2684,
    "乌什县": 2685,
    "喀什市": 2687,
    "巴楚县": 2688,
    "泽普县": 2689,
    "伽师县": 2690,
    "叶城县": 2691,
    "岳普湖县": 2692,
    "疏附县": 2693,
    "疏勒县": 2694,
    "英吉沙县": 2695,
    "麦盖提县": 2696,
    "莎车县": 2697,
    "塔什库尔干县": 2698,
    "阿图什市": 2700,
    "阿合奇县": 2701,
    "乌恰县": 2702,
    "阿克陶县": 2703,
    "库尔勒市": 2705,
    "尉犁县": 2706,
    "和静县": 2707,
    "博湖县": 2708,
    "和硕县": 2709,
    "轮台县": 2710,
    "若羌县": 2711,
    "且末县": 2712,
    "焉耆县": 2713,
    "昌吉市": 2715,
    "阜康市": 2716,
    "奇台县": 2718,
    "玛纳斯县": 2719,
    "吉木萨尔县": 2720,
    "呼图壁县": 2721,
    "木垒县": 2722,
    "博乐市": 2724,
    "精河县": 2725,
    "温泉县": 2726,
    "阿拉山口市": 52790,
    "伊宁市": 2728,
    "特克斯县": 2729,
    "尼勒克县": 2730,
    "昭苏县": 2731,
    "新源县": 2732,
    "霍城县": 2733,
    "察布查尔县": 2734,
    "巩留县": 2735,
    "奎屯市": 4028,
    "伊宁县": 4499,
    "霍尔果斯市": 53694,
    "塔城市": 2737,
    "乌苏市": 2738,
    "额敏县": 2739,
    "裕民县": 2740,
    "沙湾县": 2741,
    "托里县": 2742,
    "和布克赛尔县": 2743,
    "阿勒泰市": 2745,
    "富蕴县": 2746,
    "青河县": 2747,
    "吉木乃县": 2748,
    "布尔津县": 2749,
    "福海县": 2750,
    "哈巴河县": 2751,
    "北屯市": 6822,
    "五家渠市": 4122,
    "阿拉尔市": 15948,
    "图木舒克市": 15947,
    "铁门关市": 53108,
    "昆玉市": 53688,
    "彰化": 53497,
    "嘉义": 53498,
    "新竹": 53499,
    "花莲": 53500,
    "宜兰": 53501,
    "高雄": 53502,
    "基隆": 53503,
    "金门": 53504,
    "连江": 53505,
    "苗栗": 53506,
    "南投": 53507,
    "澎湖": 53508,
    "屏东": 53509,
    "台东": 53510,
    "台中": 53511,
    "台南": 53512,
    "台北": 53513,
    "桃园": 53514,
    "云林": 53515,
    "新北": 53516,
    "钓鱼岛县": 53262,
    "钓鱼岛县1": 53263,
    "钓鱼岛全区": 53281,
    "中西区": 52996,
    "东区": 52997,
    "九龙城区": 52998,
    "观塘区": 52999,
    "深水埗区": 53000,
    "湾仔区": 53001,
    "黄大仙区": 53002,
    "油尖旺区": 53003,
    "离岛区": 53004,
    "葵青区": 53005,
    "北区": 53006,
    "西贡区": 53007,
    "沙田区": 53008,
    "屯门区": 53009,
    "大埔区": 53010,
    "荃湾区": 53011,
    "元朗区": 53012,
    "香港": 53013,
    "九龙": 53014,
    "新界": 53015,
    "澳门特别行政区": 53016,
    "澳门半岛": 53017,
    "凼仔": 53018,
    "路凼城": 53019,
    "路环": 53020,
    "": 0,
  },

};
export {City};



// WEBPACK FOOTER //
// ./src/assets/js/city.js